var items = {
  "block.minecraft.acacia_button": "Agacowy knefel",
  "block.minecraft.acacia_door": "Agacowe dźwiyrze",
  "block.minecraft.acacia_fence": "Agacowy płot",
  "block.minecraft.acacia_fence_gate": "Agacowo wrōtka",
  "block.minecraft.acacia_hanging_sign": "Agacowy szild",
  "block.minecraft.acacia_leaves": "Liście agacu",
  "block.minecraft.acacia_log": "Sztam agacu",
  "block.minecraft.acacia_planks": "Agacowe brety",
  "block.minecraft.acacia_pressure_plate": "Agacowo drukplata",
  "block.minecraft.acacia_sapling": "Flancka agacu",
  "block.minecraft.acacia_shelf": "Agacowo pōłka",
  "block.minecraft.acacia_sign": "Agacowy znak",
  "block.minecraft.acacia_slab": "Agacowo fliza",
  "block.minecraft.acacia_stairs": "Agacowe słody",
  "block.minecraft.acacia_trapdoor": "Agacowo szłapa",
  "block.minecraft.acacia_wall_hanging_sign": "Agacowy ściynny szild",
  "block.minecraft.acacia_wall_sign": "Agacowy ściynny znak",
  "block.minecraft.acacia_wood": "Agacowe drzewo",
  "block.minecraft.activator_rail": "Aktywacyjne glajzy",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Knobloch",
  "block.minecraft.amethyst_block": "Blok ametystu",
  "block.minecraft.amethyst_cluster": "Klōmp ametystu",
  "block.minecraft.ancient_debris": "Chańdowne wygorzelisko",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezitowo fliza",
  "block.minecraft.andesite_stairs": "Andezitowe słody",
  "block.minecraft.andesite_wall": "Andezitowy murek",
  "block.minecraft.anvil": "Ambos",
  "block.minecraft.attached_melon_stem": "Prziłōnczōny sztyngel wasermelōna",
  "block.minecraft.attached_pumpkin_stem": "Prziłōnczōny sztyngel banie",
  "block.minecraft.azalea": "Azalijo",
  "block.minecraft.azalea_leaves": "Liście azalije",
  "block.minecraft.azure_bluet": "Lazurowo hiustōnijo",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok bambusa",
  "block.minecraft.bamboo_button": "Bambusowy knefel",
  "block.minecraft.bamboo_door": "Bambusowe dźwiyrze",
  "block.minecraft.bamboo_fence": "Bambusowy płot",
  "block.minecraft.bamboo_fence_gate": "Bambusowo wrōtka",
  "block.minecraft.bamboo_hanging_sign": "Bambusowy szild",
  "block.minecraft.bamboo_mosaic": "Bambusowy sztukwerk",
  "block.minecraft.bamboo_mosaic_slab": "Bambusowo sztukwerkowo fliza",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusowe sztukwerkowe słody",
  "block.minecraft.bamboo_planks": "Bambusowe brety",
  "block.minecraft.bamboo_pressure_plate": "Bambusowo drukplata",
  "block.minecraft.bamboo_sapling": "Pynd bambusa",
  "block.minecraft.bamboo_shelf": "Bambusowo pōłka",
  "block.minecraft.bamboo_sign": "Bambusowy znak",
  "block.minecraft.bamboo_slab": "Bambusowo fliza",
  "block.minecraft.bamboo_stairs": "Bambusowe słody",
  "block.minecraft.bamboo_trapdoor": "Bambusowo szłapa",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambusowy ściynny szild",
  "block.minecraft.bamboo_wall_sign": "Bambusowy ściynny znak",
  "block.minecraft.banner.base.black": "Czorne tło",
  "block.minecraft.banner.base.blue": "Modre tło",
  "block.minecraft.banner.base.brown": "Brōnotne tło",
  "block.minecraft.banner.base.cyan": "Cyjanowe tło",
  "block.minecraft.banner.base.gray": "Siwe tło",
  "block.minecraft.banner.base.green": "Zielōne tło",
  "block.minecraft.banner.base.light_blue": "Światłomodre tło",
  "block.minecraft.banner.base.light_gray": "Światłosiwe tło",
  "block.minecraft.banner.base.lime": "Limōnkowe tło",
  "block.minecraft.banner.base.magenta": "Purpurowe tło",
  "block.minecraft.banner.base.orange": "Ôranżowe tło",
  "block.minecraft.banner.base.pink": "Rōżowe tło",
  "block.minecraft.banner.base.purple": "Flidrowe tło",
  "block.minecraft.banner.base.red": "Czyrwōne tło",
  "block.minecraft.banner.base.white": "Biołe tło",
  "block.minecraft.banner.base.yellow": "Żōłte tło",
  "block.minecraft.banner.border.black": "Czorno rōma",
  "block.minecraft.banner.border.blue": "Modro rōma",
  "block.minecraft.banner.border.brown": "Brōnotno rōma",
  "block.minecraft.banner.border.cyan": "Cyjanowo rōma",
  "block.minecraft.banner.border.gray": "Siwo rōma",
  "block.minecraft.banner.border.green": "Zielōno rōma",
  "block.minecraft.banner.border.light_blue": "Światłomodro rōma",
  "block.minecraft.banner.border.light_gray": "Światłosiwo rōma",
  "block.minecraft.banner.border.lime": "Limōnkowo rōma",
  "block.minecraft.banner.border.magenta": "Purpurowo rōma",
  "block.minecraft.banner.border.orange": "Ôranżowo rōma",
  "block.minecraft.banner.border.pink": "Rōżowo rōma",
  "block.minecraft.banner.border.purple": "Flidrowo rōma",
  "block.minecraft.banner.border.red": "Czyrwōno rōma",
  "block.minecraft.banner.border.white": "Bioło rōma",
  "block.minecraft.banner.border.yellow": "Żōłto rōma",
  "block.minecraft.banner.bricks.black": "Czorny mur",
  "block.minecraft.banner.bricks.blue": "Modry mur",
  "block.minecraft.banner.bricks.brown": "Brōnotny mur",
  "block.minecraft.banner.bricks.cyan": "Cyjanowy mur",
  "block.minecraft.banner.bricks.gray": "Siwy mur",
  "block.minecraft.banner.bricks.green": "Zielōny mur",
  "block.minecraft.banner.bricks.light_blue": "Światłomodry mur",
  "block.minecraft.banner.bricks.light_gray": "Światłosiwy mur",
  "block.minecraft.banner.bricks.lime": "Limōnkowy mur",
  "block.minecraft.banner.bricks.magenta": "Purpurowy mur",
  "block.minecraft.banner.bricks.orange": "Ôranżowy mur",
  "block.minecraft.banner.bricks.pink": "Rōżowy mur",
  "block.minecraft.banner.bricks.purple": "Flidrowy mur",
  "block.minecraft.banner.bricks.red": "Czyrwōny mur",
  "block.minecraft.banner.bricks.white": "Bioły mur",
  "block.minecraft.banner.bricks.yellow": "Żōłty mur",
  "block.minecraft.banner.circle.black": "Czorne rōnto",
  "block.minecraft.banner.circle.blue": "Modre rōnto",
  "block.minecraft.banner.circle.brown": "Brōnotne rōnto",
  "block.minecraft.banner.circle.cyan": "Cyjanowe rōnto",
  "block.minecraft.banner.circle.gray": "Siwe rōnto",
  "block.minecraft.banner.circle.green": "Zielōne rōnto",
  "block.minecraft.banner.circle.light_blue": "Światłomodre rōnto",
  "block.minecraft.banner.circle.light_gray": "Światłosiwe rōnto",
  "block.minecraft.banner.circle.lime": "Limōnkowe rōnto",
  "block.minecraft.banner.circle.magenta": "Purpurowe rōnto",
  "block.minecraft.banner.circle.orange": "Ôranżowe rōnto",
  "block.minecraft.banner.circle.pink": "Rōżowe rōnto",
  "block.minecraft.banner.circle.purple": "Flidrowe rōnto",
  "block.minecraft.banner.circle.red": "Czyrwōne rōnto",
  "block.minecraft.banner.circle.white": "Biołe rōnto",
  "block.minecraft.banner.circle.yellow": "Żōłte rōnto",
  "block.minecraft.banner.creeper.black": "Czorny creeper",
  "block.minecraft.banner.creeper.blue": "Modry creeper",
  "block.minecraft.banner.creeper.brown": "Brōnotny creeper",
  "block.minecraft.banner.creeper.cyan": "Cyjanowy creeper",
  "block.minecraft.banner.creeper.gray": "Siwy creeper",
  "block.minecraft.banner.creeper.green": "Zielōny creeper",
  "block.minecraft.banner.creeper.light_blue": "Światłomodry creeper",
  "block.minecraft.banner.creeper.light_gray": "Światłosiwy creeper",
  "block.minecraft.banner.creeper.lime": "Limōnkowy creeper",
  "block.minecraft.banner.creeper.magenta": "Purpurowy creeper",
  "block.minecraft.banner.creeper.orange": "Ôranżowy creeper",
  "block.minecraft.banner.creeper.pink": "Rōżowy creeper",
  "block.minecraft.banner.creeper.purple": "Flidrowy creeper",
  "block.minecraft.banner.creeper.red": "Czyrwōny creeper",
  "block.minecraft.banner.creeper.white": "Bioły creeper",
  "block.minecraft.banner.creeper.yellow": "Żōłty creeper",
  "block.minecraft.banner.cross.black": "Czorny kośny krziż",
  "block.minecraft.banner.cross.blue": "Modry kośny krziż",
  "block.minecraft.banner.cross.brown": "Brōnotny kośny krziż",
  "block.minecraft.banner.cross.cyan": "Cyjanowy kośny krziż",
  "block.minecraft.banner.cross.gray": "Siwy kośny krziż",
  "block.minecraft.banner.cross.green": "Zielōny kośny krziż",
  "block.minecraft.banner.cross.light_blue": "Światłomodry kośny krziż",
  "block.minecraft.banner.cross.light_gray": "Światłosiwy kośny krziż",
  "block.minecraft.banner.cross.lime": "Limōnkowy kośny krziż",
  "block.minecraft.banner.cross.magenta": "Purpurowy kośny krziż",
  "block.minecraft.banner.cross.orange": "Ôranżowy kośny krziż",
  "block.minecraft.banner.cross.pink": "Rōżowy kośny krziż",
  "block.minecraft.banner.cross.purple": "Flidrowy kośny krziż",
  "block.minecraft.banner.cross.red": "Czyrwōny kośny krziż",
  "block.minecraft.banner.cross.white": "Bioły kośny krziż",
  "block.minecraft.banner.cross.yellow": "Żōłty kośny krziż",
  "block.minecraft.banner.curly_border.black": "Czorno faltowano rōma",
  "block.minecraft.banner.curly_border.blue": "Modro faltowano rōma",
  "block.minecraft.banner.curly_border.brown": "Brōnotno faltowano rōma",
  "block.minecraft.banner.curly_border.cyan": "Cyjanowo faltowano rōma",
  "block.minecraft.banner.curly_border.gray": "Siwo faltowano rōma",
  "block.minecraft.banner.curly_border.green": "Zielōno faltowano rōma",
  "block.minecraft.banner.curly_border.light_blue": "Światłomodro faltowano rōma",
  "block.minecraft.banner.curly_border.light_gray": "Światłosiwo faltowano rōma",
  "block.minecraft.banner.curly_border.lime": "Limōnkowo faltowano rōma",
  "block.minecraft.banner.curly_border.magenta": "Purpurowo faltowano rōma",
  "block.minecraft.banner.curly_border.orange": "Ôranżowo faltowano rōma",
  "block.minecraft.banner.curly_border.pink": "Rōżowo faltowano rōma",
  "block.minecraft.banner.curly_border.purple": "Flidrowo faltowano rōma",
  "block.minecraft.banner.curly_border.red": "Czyrwōno faltowano rōma",
  "block.minecraft.banner.curly_border.white": "Bioło faltowano rōma",
  "block.minecraft.banner.curly_border.yellow": "Żōłto faltowano rōma",
  "block.minecraft.banner.diagonal_left.black": "Czorny kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.blue": "Modry kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.brown": "Brōnotny kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.cyan": "Cyjanowy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.gray": "Siwy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.green": "Zielōny kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.light_blue": "Światłomodry kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.light_gray": "Światłosiwy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.lime": "Limōnkowy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurowy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.orange": "Ôranżowy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.pink": "Rōżowy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.purple": "Flidrowy kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.red": "Czyrwōny kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.white": "Bioły kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_left.yellow": "Żōłty kośny lewy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.black": "Czorny kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.blue": "Modry kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.brown": "Brōnotny kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.cyan": "Cyjanowy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.gray": "Siwy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.green": "Zielōny kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.light_blue": "Światłomodry kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.light_gray": "Światłosiwy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.lime": "Limōnkowy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurowy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.orange": "Ôranżowy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.pink": "Rōżowy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.purple": "Flidrowy kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.red": "Czyrwōny kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.white": "Bioły kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_right.yellow": "Żōłty kośny prawy wiyrchni połek",
  "block.minecraft.banner.diagonal_up_left.black": "Czorny kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.blue": "Modry kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.brown": "Brōnotny kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyjanowy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.gray": "Siwy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.green": "Zielōny kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Światłomodry kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Światłosiwy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.lime": "Limōnkowy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurowy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.orange": "Ôranżowy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.pink": "Rōżowy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.purple": "Flidrowy kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.red": "Czyrwōny kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.white": "Bioły kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_left.yellow": "Żōłty kośny lewy spodni połek",
  "block.minecraft.banner.diagonal_up_right.black": "Czorny kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.blue": "Modry kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.brown": "Brōnotny kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.cyan": "Cyjanowy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.gray": "Siwy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.green": "Zielōny kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Światłomodry kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Światłosiwy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.lime": "Limōnkowy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurowy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.orange": "Ôranżowy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.pink": "Rōżowy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.purple": "Lilowy kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.red": "Czyrwōny kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.white": "Bioły kośny prawy spodni połek",
  "block.minecraft.banner.diagonal_up_right.yellow": "Żōłty kośny prawy spodni połek",
  "block.minecraft.banner.flow.black": "Czorny wir",
  "block.minecraft.banner.flow.blue": "Modry wir",
  "block.minecraft.banner.flow.brown": "Brōnotny wir",
  "block.minecraft.banner.flow.cyan": "Cyjanowy wir",
  "block.minecraft.banner.flow.gray": "Siwy wir",
  "block.minecraft.banner.flow.green": "Zielōny wir",
  "block.minecraft.banner.flow.light_blue": "Światłomodry wir",
  "block.minecraft.banner.flow.light_gray": "Światłosiwy wir",
  "block.minecraft.banner.flow.lime": "Limōnkowy wir",
  "block.minecraft.banner.flow.magenta": "Purpurowy wir",
  "block.minecraft.banner.flow.orange": "Ôranżowy wir",
  "block.minecraft.banner.flow.pink": "Rōżowy wir",
  "block.minecraft.banner.flow.purple": "Flidrowy wir",
  "block.minecraft.banner.flow.red": "Czyrwōny wir",
  "block.minecraft.banner.flow.white": "Bioły wir",
  "block.minecraft.banner.flow.yellow": "Żōłty wir",
  "block.minecraft.banner.flower.black": "Czorny kwiotek",
  "block.minecraft.banner.flower.blue": "Modry kwiotek",
  "block.minecraft.banner.flower.brown": "Brōnotny kwiotek",
  "block.minecraft.banner.flower.cyan": "Cyjanowy kwiotek",
  "block.minecraft.banner.flower.gray": "Siwy kwiotek",
  "block.minecraft.banner.flower.green": "Zielōny kwiotek",
  "block.minecraft.banner.flower.light_blue": "Światłomodry kwiotek",
  "block.minecraft.banner.flower.light_gray": "Światłosiwy kwiotek",
  "block.minecraft.banner.flower.lime": "Limōnkowy kwiotek",
  "block.minecraft.banner.flower.magenta": "Purpurowy kwiotek",
  "block.minecraft.banner.flower.orange": "Ôranżowy kwiotek",
  "block.minecraft.banner.flower.pink": "Rōżowy kwiotek",
  "block.minecraft.banner.flower.purple": "Flidrowy kwiotek",
  "block.minecraft.banner.flower.red": "Czyrwōny kwiotek",
  "block.minecraft.banner.flower.white": "Bioły kwiotek",
  "block.minecraft.banner.flower.yellow": "Żōłty kwiotek",
  "block.minecraft.banner.globe.black": "Czorno ziymiokostka",
  "block.minecraft.banner.globe.blue": "Modro ziymiokostka",
  "block.minecraft.banner.globe.brown": "Brōnotno ziymiokostka",
  "block.minecraft.banner.globe.cyan": "Cyjanowo ziymiokostka",
  "block.minecraft.banner.globe.gray": "Siwo ziymiokostka",
  "block.minecraft.banner.globe.green": "Zielōno ziymiokostka",
  "block.minecraft.banner.globe.light_blue": "Światłomodro ziymiokostka",
  "block.minecraft.banner.globe.light_gray": "Światłosiwo ziymiokostka",
  "block.minecraft.banner.globe.lime": "Limōnkowo ziymiokostka",
  "block.minecraft.banner.globe.magenta": "Purpurowo ziymiokostka",
  "block.minecraft.banner.globe.orange": "Ôranżowo ziymiokostka",
  "block.minecraft.banner.globe.pink": "Rōżowo ziymiokostka",
  "block.minecraft.banner.globe.purple": "Flidrowo ziymokostka",
  "block.minecraft.banner.globe.red": "Czyrwōno ziymiokostka",
  "block.minecraft.banner.globe.white": "Bioło ziymiokostka",
  "block.minecraft.banner.globe.yellow": "Żōłto ziymiokostka",
  "block.minecraft.banner.gradient.black": "Czorny gradiynt",
  "block.minecraft.banner.gradient.blue": "Modry gradiynt",
  "block.minecraft.banner.gradient.brown": "Brōnotny gradiynt",
  "block.minecraft.banner.gradient.cyan": "Cyjanowy gradiynt",
  "block.minecraft.banner.gradient.gray": "Siwy gradiynt",
  "block.minecraft.banner.gradient.green": "Zielōny gradiynt",
  "block.minecraft.banner.gradient.light_blue": "Światłomodry gradiynt",
  "block.minecraft.banner.gradient.light_gray": "Światłosiwy gradiynt",
  "block.minecraft.banner.gradient.lime": "Limōnkowy gradiynt",
  "block.minecraft.banner.gradient.magenta": "Purpurowy gradiynt",
  "block.minecraft.banner.gradient.orange": "Ôranżowy gradiynt",
  "block.minecraft.banner.gradient.pink": "Rōżowy gradiynt",
  "block.minecraft.banner.gradient.purple": "Flidrowy gradiynt",
  "block.minecraft.banner.gradient.red": "Czyrwōny gradiynt",
  "block.minecraft.banner.gradient.white": "Bioły gradiynt",
  "block.minecraft.banner.gradient.yellow": "Żōłty gradiynt",
  "block.minecraft.banner.gradient_up.black": "Czorny ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.blue": "Modry ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.brown": "Brōnotny ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.cyan": "Cyjanowy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.gray": "Siwy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.green": "Zielōny ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.light_blue": "Świałomodry ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.light_gray": "Światłosiwy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.lime": "Limōnkowy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.magenta": "Purpurowy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.orange": "Ôranżowy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.pink": "Rōżowy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.purple": "Flidrowy ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.red": "Czyrwōny ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.white": "Bioły ôbrōcōny gradiynt",
  "block.minecraft.banner.gradient_up.yellow": "Żōłty ôbrōcōny gradiynt",
  "block.minecraft.banner.guster.black": "Czorny wiytrzik",
  "block.minecraft.banner.guster.blue": "Modry wiytrzik",
  "block.minecraft.banner.guster.brown": "Brōnotny wiytrzik",
  "block.minecraft.banner.guster.cyan": " Cyjanowy wiytrzik",
  "block.minecraft.banner.guster.gray": "Siwy wiytrzik",
  "block.minecraft.banner.guster.green": "Zielōny wiytrzik",
  "block.minecraft.banner.guster.light_blue": "Światłomodry wiytrzik",
  "block.minecraft.banner.guster.light_gray": "Światłosiwy wiytrzik",
  "block.minecraft.banner.guster.lime": "Limōnkowy wiytrzik",
  "block.minecraft.banner.guster.magenta": "Purpurowy wiytrzik",
  "block.minecraft.banner.guster.orange": "Ôranżowy wiytrzik",
  "block.minecraft.banner.guster.pink": "Rōżowy wiytrzik",
  "block.minecraft.banner.guster.purple": "Flidrowy wiytrzik",
  "block.minecraft.banner.guster.red": "Czyrwōny wiytrzik",
  "block.minecraft.banner.guster.white": "Bioły wiytrzik",
  "block.minecraft.banner.guster.yellow": "Żōłty wiytrzik",
  "block.minecraft.banner.half_horizontal.black": "Czorny wiyrchni połek",
  "block.minecraft.banner.half_horizontal.blue": "Modry wiyrchni połek",
  "block.minecraft.banner.half_horizontal.brown": "Brōnotny wiyrchni połek",
  "block.minecraft.banner.half_horizontal.cyan": "Cyjanowy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.gray": "Siwy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.green": "Zielōny wiyrchni połek",
  "block.minecraft.banner.half_horizontal.light_blue": "Światłomodry wiyrchni połek",
  "block.minecraft.banner.half_horizontal.light_gray": "Światłosiwy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.lime": "Limōnkowy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurowy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.orange": "Ôranżowy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.pink": "Rōżowy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.purple": "Flidrowy wiyrchni połek",
  "block.minecraft.banner.half_horizontal.red": "Czyrwōny wiyrchni połek",
  "block.minecraft.banner.half_horizontal.white": "Bioły wiyrchni połek",
  "block.minecraft.banner.half_horizontal.yellow": "Żōłty wiyrchni połek",
  "block.minecraft.banner.half_horizontal_bottom.black": "Czorny spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Modry spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brōnotny spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyjanowy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Siwy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zielōny spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Światłomodry spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Światłosiwy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limōnkowy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurowy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Ôranżowy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rōżowy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Flidrowy spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.red": "Czyrwōny spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.white": "Bioły spodni połek",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Żōłty spodni połek",
  "block.minecraft.banner.half_vertical.black": "Czorny lewy połek",
  "block.minecraft.banner.half_vertical.blue": "Modry lewy połek",
  "block.minecraft.banner.half_vertical.brown": "Brōnotny lewy połek",
  "block.minecraft.banner.half_vertical.cyan": "Cyjanowy lewy połek",
  "block.minecraft.banner.half_vertical.gray": "Siwy lewy połek",
  "block.minecraft.banner.half_vertical.green": "Zielōny lewy połek",
  "block.minecraft.banner.half_vertical.light_blue": "Światłomodry lewy połek",
  "block.minecraft.banner.half_vertical.light_gray": "Światłosiwy lewy połek",
  "block.minecraft.banner.half_vertical.lime": "Limōnkowy lewy połek",
  "block.minecraft.banner.half_vertical.magenta": "Purpurowy lewy połek",
  "block.minecraft.banner.half_vertical.orange": "Ôranżowy lewy połek",
  "block.minecraft.banner.half_vertical.pink": "Rōżowy lewy połek",
  "block.minecraft.banner.half_vertical.purple": "Flidrowy lewy połek",
  "block.minecraft.banner.half_vertical.red": "Czyrwōny lewy połek",
  "block.minecraft.banner.half_vertical.white": "Bioły lewy połek",
  "block.minecraft.banner.half_vertical.yellow": "Żōłty lewy połek",
  "block.minecraft.banner.half_vertical_right.black": "Czorny prawy połek",
  "block.minecraft.banner.half_vertical_right.blue": "Modry prawy połek",
  "block.minecraft.banner.half_vertical_right.brown": "Brōnotny prawy połek",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyjanowy prawy połek",
  "block.minecraft.banner.half_vertical_right.gray": "Siwy prawy połek",
  "block.minecraft.banner.half_vertical_right.green": "Zielōny prawy połek",
  "block.minecraft.banner.half_vertical_right.light_blue": "Światłomodry prawy połek",
  "block.minecraft.banner.half_vertical_right.light_gray": "Światłosiwy prawy połek",
  "block.minecraft.banner.half_vertical_right.lime": "Limōnkowy prawy połek",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurowy prawy połek",
  "block.minecraft.banner.half_vertical_right.orange": "Ôranżowy prawy połek",
  "block.minecraft.banner.half_vertical_right.pink": "Rōżowy prawy połek",
  "block.minecraft.banner.half_vertical_right.purple": "Flidrowy prawy połek",
  "block.minecraft.banner.half_vertical_right.red": "Czyrwōny prawy połek",
  "block.minecraft.banner.half_vertical_right.white": "Bioły prawy połek",
  "block.minecraft.banner.half_vertical_right.yellow": "Żōłty prawy połek",
  "block.minecraft.banner.mojang.black": "Czorne coś",
  "block.minecraft.banner.mojang.blue": "Modre coś",
  "block.minecraft.banner.mojang.brown": "Brōnotne coś",
  "block.minecraft.banner.mojang.cyan": "Cyjanowe coś",
  "block.minecraft.banner.mojang.gray": "Siwe coś",
  "block.minecraft.banner.mojang.green": "Zielōne coś",
  "block.minecraft.banner.mojang.light_blue": "Światłomodre coś",
  "block.minecraft.banner.mojang.light_gray": "Światłosiwe coś",
  "block.minecraft.banner.mojang.lime": "Limōnkowe coś",
  "block.minecraft.banner.mojang.magenta": "Purpurowe coś",
  "block.minecraft.banner.mojang.orange": "Ôranżowe coś",
  "block.minecraft.banner.mojang.pink": "Rōżowe coś",
  "block.minecraft.banner.mojang.purple": "Flidrowe coś",
  "block.minecraft.banner.mojang.red": "Czyrwōne coś",
  "block.minecraft.banner.mojang.white": "Biołe coś",
  "block.minecraft.banner.mojang.yellow": "Żōłte coś",
  "block.minecraft.banner.piglin.black": "Czorny niurok",
  "block.minecraft.banner.piglin.blue": "Modry niurok",
  "block.minecraft.banner.piglin.brown": "Brōnotny niurok",
  "block.minecraft.banner.piglin.cyan": "Cyjanowy niurok",
  "block.minecraft.banner.piglin.gray": "Siwy niurok",
  "block.minecraft.banner.piglin.green": "Zielōny niurok",
  "block.minecraft.banner.piglin.light_blue": "Światłomodry niurok",
  "block.minecraft.banner.piglin.light_gray": "Światłosiwy niurok",
  "block.minecraft.banner.piglin.lime": "Limōnkowy niurok",
  "block.minecraft.banner.piglin.magenta": "Purpurowy niurok",
  "block.minecraft.banner.piglin.orange": "Ôranżowy niurok",
  "block.minecraft.banner.piglin.pink": "Rōżowy niurok",
  "block.minecraft.banner.piglin.purple": "Flidrowy niurok",
  "block.minecraft.banner.piglin.red": "Czyrwōny niurok",
  "block.minecraft.banner.piglin.white": "Bioły niurok",
  "block.minecraft.banner.piglin.yellow": "Żōłty niurok",
  "block.minecraft.banner.rhombus.black": "Czorny rōmb",
  "block.minecraft.banner.rhombus.blue": "Modry rōmb",
  "block.minecraft.banner.rhombus.brown": "Brōnotny rōmb",
  "block.minecraft.banner.rhombus.cyan": "Cyjanowy rōmb",
  "block.minecraft.banner.rhombus.gray": "Siwy rōmb",
  "block.minecraft.banner.rhombus.green": "Zielōny rōmb",
  "block.minecraft.banner.rhombus.light_blue": "Światłomodry rōmb",
  "block.minecraft.banner.rhombus.light_gray": "Światłosiwy rōmb",
  "block.minecraft.banner.rhombus.lime": "Limōnkowy rōmb",
  "block.minecraft.banner.rhombus.magenta": "Purpurowy rōmb",
  "block.minecraft.banner.rhombus.orange": "Ôranżowy rōmb",
  "block.minecraft.banner.rhombus.pink": "Rōżowy rōmb",
  "block.minecraft.banner.rhombus.purple": "Flidrowy rōmb",
  "block.minecraft.banner.rhombus.red": "Czyrwōny rōmb",
  "block.minecraft.banner.rhombus.white": "Bioły rōmb",
  "block.minecraft.banner.rhombus.yellow": "Żōłty rōmb",
  "block.minecraft.banner.skull.black": "Czorno trōpio szala",
  "block.minecraft.banner.skull.blue": "Modro trōpio szala",
  "block.minecraft.banner.skull.brown": "Brōnotno trōpio szala",
  "block.minecraft.banner.skull.cyan": "Cyjanowo trōpio szala",
  "block.minecraft.banner.skull.gray": "Siwo trōpio szala",
  "block.minecraft.banner.skull.green": "Zielōno trōpio szala",
  "block.minecraft.banner.skull.light_blue": "Światłomodro trōpio szala",
  "block.minecraft.banner.skull.light_gray": "Światłosiwo trōpio szala",
  "block.minecraft.banner.skull.lime": "Limōnkowo trōpio szala",
  "block.minecraft.banner.skull.magenta": "Purpurowo trōpio szala",
  "block.minecraft.banner.skull.orange": "Ôranżowo trōpio szala",
  "block.minecraft.banner.skull.pink": "Rōżowo trōpio szala",
  "block.minecraft.banner.skull.purple": "Flidrowo trōpio szala",
  "block.minecraft.banner.skull.red": "Czyrwōno trōpio szala",
  "block.minecraft.banner.skull.white": "Bioło trōpio szala",
  "block.minecraft.banner.skull.yellow": "Żōłto trōpio szala",
  "block.minecraft.banner.small_stripes.black": "Czorne poski",
  "block.minecraft.banner.small_stripes.blue": "Modre poski",
  "block.minecraft.banner.small_stripes.brown": "Brōnotne poski",
  "block.minecraft.banner.small_stripes.cyan": "Cyjanowe poski",
  "block.minecraft.banner.small_stripes.gray": "Siwe poski",
  "block.minecraft.banner.small_stripes.green": "Zielōne poski",
  "block.minecraft.banner.small_stripes.light_blue": "Światłomodre poski",
  "block.minecraft.banner.small_stripes.light_gray": "Światłosiwe poski",
  "block.minecraft.banner.small_stripes.lime": "Limōnkowe poski",
  "block.minecraft.banner.small_stripes.magenta": "Purpurowe poski",
  "block.minecraft.banner.small_stripes.orange": "Ôranżowe poski",
  "block.minecraft.banner.small_stripes.pink": "Rōżowe poski",
  "block.minecraft.banner.small_stripes.purple": "Flidrowe poski",
  "block.minecraft.banner.small_stripes.red": "Czyrwōne poski",
  "block.minecraft.banner.small_stripes.white": "Biołe poski",
  "block.minecraft.banner.small_stripes.yellow": "Żōłte poski",
  "block.minecraft.banner.square_bottom_left.black": "Czorno spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.blue": "Modro spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.brown": "Brōnotno spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.cyan": "Cyjanowo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.gray": "Siwo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.green": "Zielōno spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.light_blue": "Światłomodro spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.light_gray": "Światłosiwo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.lime": "Limōnkowo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurowo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.orange": "Ôranżowo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.pink": "Rōżowo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.purple": "Flidrowo spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.red": "Czyrwōno spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.white": "Bioło spodnio lewo eka",
  "block.minecraft.banner.square_bottom_left.yellow": "Żōłto spodnio lewo eka",
  "block.minecraft.banner.square_bottom_right.black": "Czorno spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.blue": "Modro spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.brown": "Brōnotno spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyjanowo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.gray": "Siwo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.green": "Zielōno spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.light_blue": "Światłomodro spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.light_gray": "Światłosiwo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.lime": "Limōnkowo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurowo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.orange": "Ôranżowo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.pink": "Rōżowo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.purple": "Flidrowo spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.red": "Czyrwōno spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.white": "Bioło spodnio prawo eka",
  "block.minecraft.banner.square_bottom_right.yellow": "Żōłto spodnio prawo eka",
  "block.minecraft.banner.square_top_left.black": "Czorno wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.blue": "Modro wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.brown": "Brōnotno wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.cyan": "Cyjanowo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.gray": "Siwo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.green": "Zielōno wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.light_blue": "Światłomodro wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.light_gray": "Światłosiwo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.lime": "Limōnkowo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.magenta": "Purpurowo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.orange": "Ôranżowo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.pink": "Rōżowo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.purple": "Flidrowo wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.red": "Czyrwōno wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.white": "Bioło wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_left.yellow": "Żōłto wiyrchnio lewo eka",
  "block.minecraft.banner.square_top_right.black": "Czorno wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.blue": "Modro wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.brown": "Brōnotno wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.cyan": "Cyjanowo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.gray": "Siwo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.green": "Zielōno wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.light_blue": "Światłomodro wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.light_gray": "Światłosiwo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.lime": "Limōnkowo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.magenta": "Purpurowo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.orange": "Ôranżowo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.pink": "Rōżowo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.purple": "Flidrowo wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.red": "Czyrwōno wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.white": "Bioło wiyrchnio prawo eka",
  "block.minecraft.banner.square_top_right.yellow": "Żōłto wiyrchnio prawo eka",
  "block.minecraft.banner.straight_cross.black": "Czorny krziż",
  "block.minecraft.banner.straight_cross.blue": "Modry krziż",
  "block.minecraft.banner.straight_cross.brown": "Brōnotny krziż",
  "block.minecraft.banner.straight_cross.cyan": "Cyjanowy krziż",
  "block.minecraft.banner.straight_cross.gray": "Siwy krziż",
  "block.minecraft.banner.straight_cross.green": "Zielōny krziż",
  "block.minecraft.banner.straight_cross.light_blue": "Światłomodry krziż",
  "block.minecraft.banner.straight_cross.light_gray": "Światłosiwy krziż",
  "block.minecraft.banner.straight_cross.lime": "Limōnkowy krziż",
  "block.minecraft.banner.straight_cross.magenta": "Purpurowy krziż",
  "block.minecraft.banner.straight_cross.orange": "Ôranżowy krziż",
  "block.minecraft.banner.straight_cross.pink": "Rōżowy krziż",
  "block.minecraft.banner.straight_cross.purple": "Flidrowy krziż",
  "block.minecraft.banner.straight_cross.red": "Czyrwōny krziż",
  "block.minecraft.banner.straight_cross.white": "Bioły krziż",
  "block.minecraft.banner.straight_cross.yellow": "Żōłty krziż",
  "block.minecraft.banner.stripe_bottom.black": "Czorny spodni pos",
  "block.minecraft.banner.stripe_bottom.blue": "Modry spodni pos",
  "block.minecraft.banner.stripe_bottom.brown": "Brōnotny spodni pos",
  "block.minecraft.banner.stripe_bottom.cyan": "Cyjanowy spodni pos",
  "block.minecraft.banner.stripe_bottom.gray": "Siwy spodni pos",
  "block.minecraft.banner.stripe_bottom.green": "Zielōny spodni pos",
  "block.minecraft.banner.stripe_bottom.light_blue": "Światłomodry spodni pos",
  "block.minecraft.banner.stripe_bottom.light_gray": "Światłosiwy spodni pos",
  "block.minecraft.banner.stripe_bottom.lime": "Limōnkowy spodni pos",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurowy spodni pos",
  "block.minecraft.banner.stripe_bottom.orange": "Ôranżowy spodni pos",
  "block.minecraft.banner.stripe_bottom.pink": "Rōżowy spodni pos",
  "block.minecraft.banner.stripe_bottom.purple": "Flidrowy spodni pos",
  "block.minecraft.banner.stripe_bottom.red": "Czyrwōny spodni pos",
  "block.minecraft.banner.stripe_bottom.white": "Bioły spodni pos",
  "block.minecraft.banner.stripe_bottom.yellow": "Żōłty spodni pos",
  "block.minecraft.banner.stripe_center.black": "Czorny piōnowy posek",
  "block.minecraft.banner.stripe_center.blue": "Modry piōnowy posek",
  "block.minecraft.banner.stripe_center.brown": "Brōnotny piōnowy posek",
  "block.minecraft.banner.stripe_center.cyan": "Cyjanowy piōnowy posek",
  "block.minecraft.banner.stripe_center.gray": "Siwy piōnowy posek",
  "block.minecraft.banner.stripe_center.green": "Zielōny piōnowy posek",
  "block.minecraft.banner.stripe_center.light_blue": "Światłomodry piōnowy posek",
  "block.minecraft.banner.stripe_center.light_gray": "Światłosiwy piōnowy posek",
  "block.minecraft.banner.stripe_center.lime": "Limōnkowy piōnowy posek",
  "block.minecraft.banner.stripe_center.magenta": "Purpurowy piōnowy posek",
  "block.minecraft.banner.stripe_center.orange": "Ôranżowy piōnowy posek",
  "block.minecraft.banner.stripe_center.pink": "Rōżowy piōnowy posek",
  "block.minecraft.banner.stripe_center.purple": "Flidrowy piōnowy posek",
  "block.minecraft.banner.stripe_center.red": "Czyrwōny piōnowy posek",
  "block.minecraft.banner.stripe_center.white": "Bioły piōnowy posek",
  "block.minecraft.banner.stripe_center.yellow": "Żōłty piōnowy posek",
  "block.minecraft.banner.stripe_downleft.black": "Czorny kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.blue": "Modry kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.brown": "Brōnotny kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyjanowy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.gray": "Siwy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.green": "Zielōny kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.light_blue": "Światłomodry kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.light_gray": "Światłosiwy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.lime": "Limōnkowy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurowy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.orange": "Ôranżowy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.pink": "Rōżowy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.purple": "Flidrowy kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.red": "Czyrwōny kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.white": "Bioły kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downleft.yellow": "Żōłty kośny lewy spodni posek",
  "block.minecraft.banner.stripe_downright.black": "Czorny kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.blue": "Modry kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.brown": "Brōnotny kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.cyan": "Cyjanowy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.gray": "Siwy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.green": "Zielōny kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.light_blue": "Światłomodry kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.light_gray": "Światłosiwy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.lime": "Limōnkowy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurowy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.orange": "Ôranżowy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.pink": "Rōżowy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.purple": "Lilowy kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.red": "Czyrwōny kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.white": "Bioły kośny prawy spodni posek",
  "block.minecraft.banner.stripe_downright.yellow": "Żōłty kośny prawy spodni posek",
  "block.minecraft.banner.stripe_left.black": "Czorny lewy posek",
  "block.minecraft.banner.stripe_left.blue": "Modry lewy posek",
  "block.minecraft.banner.stripe_left.brown": "Brōnotny lewy posek",
  "block.minecraft.banner.stripe_left.cyan": "Cyjanowy lewy posek",
  "block.minecraft.banner.stripe_left.gray": "Siwy lewy posek",
  "block.minecraft.banner.stripe_left.green": "Zielōny lewy posek",
  "block.minecraft.banner.stripe_left.light_blue": "Światłomodry lewy posek",
  "block.minecraft.banner.stripe_left.light_gray": "Światłosiwy lewy posek",
  "block.minecraft.banner.stripe_left.lime": "Limōnkowy lewy posek",
  "block.minecraft.banner.stripe_left.magenta": "Purpurowy lewy posek",
  "block.minecraft.banner.stripe_left.orange": "Ôranżowy lewy posek",
  "block.minecraft.banner.stripe_left.pink": "Rōżowy lewy posek",
  "block.minecraft.banner.stripe_left.purple": "Flidrowy lewy posek",
  "block.minecraft.banner.stripe_left.red": "Czyrwōny lewy posek",
  "block.minecraft.banner.stripe_left.white": "Bioły lewy posek",
  "block.minecraft.banner.stripe_left.yellow": "Żōłty lewy posek",
  "block.minecraft.banner.stripe_middle.black": "Czorny poziōmy posek",
  "block.minecraft.banner.stripe_middle.blue": "Modry poziōmy posek",
  "block.minecraft.banner.stripe_middle.brown": "Brōnotny poziōmy posek",
  "block.minecraft.banner.stripe_middle.cyan": "Cyjanowy poziōmy posek",
  "block.minecraft.banner.stripe_middle.gray": "Siwy poziōmy posek",
  "block.minecraft.banner.stripe_middle.green": "Zielōny poziōmy posek",
  "block.minecraft.banner.stripe_middle.light_blue": "Światłomodry poziōmy posek",
  "block.minecraft.banner.stripe_middle.light_gray": "Światłosiwy poziōmy posek",
  "block.minecraft.banner.stripe_middle.lime": "Limōnkowy poziōmy posek",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurowy poziōmy posek",
  "block.minecraft.banner.stripe_middle.orange": "Ôranżowy poziōmy posek",
  "block.minecraft.banner.stripe_middle.pink": "Rōżowy poziōmy posek",
  "block.minecraft.banner.stripe_middle.purple": "Flidrowy poziōmy posek",
  "block.minecraft.banner.stripe_middle.red": "Czyrwōny poziōmy posek",
  "block.minecraft.banner.stripe_middle.white": "Bioły poziōmy posek",
  "block.minecraft.banner.stripe_middle.yellow": "Żōłty poziōmy posek",
  "block.minecraft.banner.stripe_right.black": "Czorny prawy posek",
  "block.minecraft.banner.stripe_right.blue": "Modry prawy posek",
  "block.minecraft.banner.stripe_right.brown": "Brōnotny prawy posek",
  "block.minecraft.banner.stripe_right.cyan": "Cyjanowy prawy posek",
  "block.minecraft.banner.stripe_right.gray": "Siwy prawy posek",
  "block.minecraft.banner.stripe_right.green": "Zielōny prawy posek",
  "block.minecraft.banner.stripe_right.light_blue": "Światłomodry prawy posek",
  "block.minecraft.banner.stripe_right.light_gray": "Światłosiwy prawy posek",
  "block.minecraft.banner.stripe_right.lime": "Limōnkowy prawy posek",
  "block.minecraft.banner.stripe_right.magenta": "Purpurowy prawy posek",
  "block.minecraft.banner.stripe_right.orange": "Ôranżowy prawy posek",
  "block.minecraft.banner.stripe_right.pink": "Rōżowy prawy posek",
  "block.minecraft.banner.stripe_right.purple": "Flidrowy prawy posek",
  "block.minecraft.banner.stripe_right.red": "Czyrwōny prawy posek",
  "block.minecraft.banner.stripe_right.white": "Bioły prawy posek",
  "block.minecraft.banner.stripe_right.yellow": "Żōłty prawy posek",
  "block.minecraft.banner.stripe_top.black": "Czorny wiyrchni pos",
  "block.minecraft.banner.stripe_top.blue": "Modry wiyrchni pos",
  "block.minecraft.banner.stripe_top.brown": "Brōnotny wiyrchni pos",
  "block.minecraft.banner.stripe_top.cyan": "Cyjanowy wiyrchni pos",
  "block.minecraft.banner.stripe_top.gray": "Siwy wiyrchni pos",
  "block.minecraft.banner.stripe_top.green": "Zielōny wiyrchni pos",
  "block.minecraft.banner.stripe_top.light_blue": "Światłomodry wiyrchni pos",
  "block.minecraft.banner.stripe_top.light_gray": "Światłosiwy wiyrchni pos",
  "block.minecraft.banner.stripe_top.lime": "Limōnkowy wiyrchni pos",
  "block.minecraft.banner.stripe_top.magenta": "Purpurowy wiyrchni pos",
  "block.minecraft.banner.stripe_top.orange": "Ôranżowy wiyrchni pos",
  "block.minecraft.banner.stripe_top.pink": "Rōżowy wiyrchni pos",
  "block.minecraft.banner.stripe_top.purple": "Flidrowy wiyrchni pos",
  "block.minecraft.banner.stripe_top.red": "Czyrwōny wiyrchni pos",
  "block.minecraft.banner.stripe_top.white": "Bioły wiyrchni pos",
  "block.minecraft.banner.stripe_top.yellow": "Żōłty wiyrch",
  "block.minecraft.banner.triangle_bottom.black": "Czorny spodni sztachel",
  "block.minecraft.banner.triangle_bottom.blue": "Modry spodni sztachel",
  "block.minecraft.banner.triangle_bottom.brown": "Brōnotny spodni sztachel",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyjanowy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.gray": "Siwy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.green": "Zielōny spodni sztachel",
  "block.minecraft.banner.triangle_bottom.light_blue": "Światłomodry spodni sztachel",
  "block.minecraft.banner.triangle_bottom.light_gray": "Światłosiwy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.lime": "Limōnkowy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurowy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.orange": "Ôranżowy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.pink": "Rōżowy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.purple": "Flidrowy spodni sztachel",
  "block.minecraft.banner.triangle_bottom.red": "Czyrwōny spodni sztachel",
  "block.minecraft.banner.triangle_bottom.white": "Bioły spodni sztachel",
  "block.minecraft.banner.triangle_bottom.yellow": "Żōłty spodni sztachel",
  "block.minecraft.banner.triangle_top.black": "Czorny wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.blue": "Modry wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.brown": "Brōnotny wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.cyan": "Cyjanowy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.gray": "Siwy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.green": "Zielōny wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.light_blue": "Światłomodry wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.light_gray": "Światłosiwy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.lime": "Limōnkowy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.magenta": "Purpurowy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.orange": "Ôranżowy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.pink": "Rōżowy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.purple": "Flidrowy wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.red": "Czyrwōny wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.white": "Bioły wiyrchni sztachel",
  "block.minecraft.banner.triangle_top.yellow": "Żōłty wiyrchni sztachel",
  "block.minecraft.banner.triangles_bottom.black": "Czorne spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.blue": "Modre spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.brown": "Brōnotne spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.cyan": "Cyjanowe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.gray": "Siwe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.green": "Zielōne spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.light_blue": "Światłomodre spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.light_gray": "Światłosiwe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.lime": "Limōnkowe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurowe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.orange": "Ôranżowe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.pink": "Rōżowe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.purple": "Flidrowe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.red": "Czyrwōne spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.white": "Biołe spodnie sztachle",
  "block.minecraft.banner.triangles_bottom.yellow": "Żōłte spodnie sztachle",
  "block.minecraft.banner.triangles_top.black": "Czorne wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.blue": "Modre wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.brown": "Brōnotne wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.cyan": "Cyjanowe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.gray": "Siwe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.green": "Zielōne wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.light_blue": "Światłomodre wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.light_gray": "Światłosiwe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.lime": "Limōnkowe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.magenta": "Purpurowe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.orange": "Ôranżowe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.pink": "Rōżowe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.purple": "Flidrowe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.red": "Czyrwōne wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.white": "Biołe wiyrchnie sztachle",
  "block.minecraft.banner.triangles_top.yellow": "Żōłte wiyrchnie sztachle",
  "block.minecraft.barrel": "Faska",
  "block.minecraft.barrier": "Bariyra",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Laterna",
  "block.minecraft.beacon.primary": "Grōntno siyła",
  "block.minecraft.beacon.secondary": "Hilfowo siyła",
  "block.minecraft.bed.no_sleep": "Śmiysz spać yno bez noc a bez burza",
  "block.minecraft.bed.not_safe": "Niy śmiysz terozki spać; wele ciebie sōm beboki",
  "block.minecraft.bed.obstructed": "To łōżko je zagrodzōne",
  "block.minecraft.bed.occupied": "To łōżko je zajmnyte",
  "block.minecraft.bed.too_far_away": "Niy śmiysz terozki spać: łōżko je za daleko",
  "block.minecraft.bedrock": "Zol",
  "block.minecraft.bee_nest": "Gniozdo binōw",
  "block.minecraft.beehive": "Hul",
  "block.minecraft.beetroots": "Ćwikle",
  "block.minecraft.bell": "Zwōn",
  "block.minecraft.big_dripleaf": "Wielgi czampiōnek",
  "block.minecraft.big_dripleaf_stem": "Sztyngel wielgego czampiōnka",
  "block.minecraft.birch_button": "Brzizkowy knefel",
  "block.minecraft.birch_door": "Brzizkowe dźwiyrze",
  "block.minecraft.birch_fence": "Brzizkowy płot",
  "block.minecraft.birch_fence_gate": "Brzizkowo wrōtka",
  "block.minecraft.birch_hanging_sign": "Brzizkowy szild",
  "block.minecraft.birch_leaves": "Liście brzizki",
  "block.minecraft.birch_log": "Sztam brzizki",
  "block.minecraft.birch_planks": "Brzizkowe brety",
  "block.minecraft.birch_pressure_plate": "Brzizkowo drukplata",
  "block.minecraft.birch_sapling": "Flancka brzizki",
  "block.minecraft.birch_shelf": "Brzizkowo pōłka",
  "block.minecraft.birch_sign": "Brzizkowy znak",
  "block.minecraft.birch_slab": "Brzizkowo fliza",
  "block.minecraft.birch_stairs": "Brzizkowe słody",
  "block.minecraft.birch_trapdoor": "Brzizkowo szłapa",
  "block.minecraft.birch_wall_hanging_sign": "Brzizkowy ściynny szild",
  "block.minecraft.birch_wall_sign": "Brzizkowy ściynny znak",
  "block.minecraft.birch_wood": "Brzizkowe drzewo",
  "block.minecraft.black_banner": "Czorno fana",
  "block.minecraft.black_bed": "Czorne łōżko",
  "block.minecraft.black_candle": "Czorno świyczka",
  "block.minecraft.black_candle_cake": "Torta ze czornōm świyczkōm",
  "block.minecraft.black_carpet": "Czorny tepich",
  "block.minecraft.black_concrete": "Czorny betōn",
  "block.minecraft.black_concrete_powder": "Czorny cymynt",
  "block.minecraft.black_glazed_terracotta": "Czorno glaziyrowano kamiōnka",
  "block.minecraft.black_shulker_box": "Czorno shulkerowo kastla",
  "block.minecraft.black_stained_glass": "Czorne szkło",
  "block.minecraft.black_stained_glass_pane": "Czorno szklanno tofla",
  "block.minecraft.black_terracotta": "Czorno kamiōnka",
  "block.minecraft.black_wool": "Czorno wołna",
  "block.minecraft.blackstone": "Czorny kamiyń",
  "block.minecraft.blackstone_slab": "Czornokamiynno fliza",
  "block.minecraft.blackstone_stairs": "Czornokamiynne słody",
  "block.minecraft.blackstone_wall": "Czornokamiynny murek",
  "block.minecraft.blast_furnace": "Hamer",
  "block.minecraft.blue_banner": "Modro fana",
  "block.minecraft.blue_bed": "Modre łōżko",
  "block.minecraft.blue_candle": "Modro świyczka",
  "block.minecraft.blue_candle_cake": "Torta ze modrōm świyczkōm",
  "block.minecraft.blue_carpet": "Modry tepich",
  "block.minecraft.blue_concrete": "Modry betōn",
  "block.minecraft.blue_concrete_powder": "Modry cymynt",
  "block.minecraft.blue_glazed_terracotta": "Modro glaziyrowano kamiōnka",
  "block.minecraft.blue_ice": "Modry lōd",
  "block.minecraft.blue_orchid": "Modry storczyk",
  "block.minecraft.blue_shulker_box": "Modro shulkerowo kastla",
  "block.minecraft.blue_stained_glass": "Modre szkło",
  "block.minecraft.blue_stained_glass_pane": "Modro szklanno tofla",
  "block.minecraft.blue_terracotta": "Modro kamiōnka",
  "block.minecraft.blue_wool": "Modro wołna",
  "block.minecraft.bone_block": "Blok kostyry",
  "block.minecraft.bookshelf": "Bicherszrank",
  "block.minecraft.brain_coral": "Mōzgowy korol",
  "block.minecraft.brain_coral_block": "Blok mōzgowego korolu",
  "block.minecraft.brain_coral_fan": "Mōzgowo gorgonia",
  "block.minecraft.brain_coral_wall_fan": "Ściynno mōzgowo gorgonia",
  "block.minecraft.brewing_stand": "Sztynder ku warzyniu",
  "block.minecraft.brick_slab": "Ceglanno fliza",
  "block.minecraft.brick_stairs": "Ceglanne słody",
  "block.minecraft.brick_wall": "Ceglanny murek",
  "block.minecraft.bricks": "Cegły",
  "block.minecraft.brown_banner": "Brōnotno fana",
  "block.minecraft.brown_bed": "Brōnotne łōżko",
  "block.minecraft.brown_candle": "Brōnotno świyczka",
  "block.minecraft.brown_candle_cake": "Torta ze brōnotnōm świyczkōm",
  "block.minecraft.brown_carpet": "Brōnotny tepich",
  "block.minecraft.brown_concrete": "Brōnotny betōn",
  "block.minecraft.brown_concrete_powder": "Brōnotny cymynt",
  "block.minecraft.brown_glazed_terracotta": "Brōnotno glaziyrowano kamiōnka",
  "block.minecraft.brown_mushroom": "Prawok",
  "block.minecraft.brown_mushroom_block": "Blok prawoka",
  "block.minecraft.brown_shulker_box": "Brōnotno shulkerowo kastla",
  "block.minecraft.brown_stained_glass": "Brōnotne szkło",
  "block.minecraft.brown_stained_glass_pane": "Brōnotno szklanno tofla",
  "block.minecraft.brown_terracotta": "Brōnotno kamiōnka",
  "block.minecraft.brown_wool": "Brōnotno wołna",
  "block.minecraft.bubble_column": "Zojla bōmbelkōw",
  "block.minecraft.bubble_coral": "Bōmbelkowy korol",
  "block.minecraft.bubble_coral_block": "Blok bōmbelkowego korolu",
  "block.minecraft.bubble_coral_fan": "Bōmbelkowo gorgonia",
  "block.minecraft.bubble_coral_wall_fan": "Ściynno bōmbelkowo gorgonia",
  "block.minecraft.budding_amethyst": "Krysztalizujōncy ametyst",
  "block.minecraft.bush": "Krzok",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kwiot kaktusa",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Kalcyt",
  "block.minecraft.calibrated_sculk_sensor": "Skalibrowany sculkowy czujnik",
  "block.minecraft.campfire": "Fojera",
  "block.minecraft.candle": "Świyczka",
  "block.minecraft.candle_cake": "Torta ze świyczkōm",
  "block.minecraft.carrots": "Markwie",
  "block.minecraft.cartography_table": "Stōł kartografa",
  "block.minecraft.carved_pumpkin": "Wystrugano bania",
  "block.minecraft.cauldron": "Kesel",
  "block.minecraft.cave_air": "Jaskiniowy luft",
  "block.minecraft.cave_vines": "Jaskiniowe kleterflance",
  "block.minecraft.cave_vines_plant": "Jaskiniowe kleterflance",
  "block.minecraft.chain": "Żelazno keta",
  "block.minecraft.chain_command_block": "Ketowy blok przikazōw",
  "block.minecraft.cherry_button": "Trześniowy knefel",
  "block.minecraft.cherry_door": "Trześniowe dźwiyrze",
  "block.minecraft.cherry_fence": "Trześniowy płot",
  "block.minecraft.cherry_fence_gate": "Trześniowo wrōtka",
  "block.minecraft.cherry_hanging_sign": "Trześniowy szild",
  "block.minecraft.cherry_leaves": "Liście trześnie",
  "block.minecraft.cherry_log": "Sztam trześnie",
  "block.minecraft.cherry_planks": "Trześniowe brety",
  "block.minecraft.cherry_pressure_plate": "Trześniowo drukplata",
  "block.minecraft.cherry_sapling": "Flancka trześnie",
  "block.minecraft.cherry_shelf": "Trześniowo pōłka",
  "block.minecraft.cherry_sign": "Trześniowy znak",
  "block.minecraft.cherry_slab": "Trześniowo fliza",
  "block.minecraft.cherry_stairs": "Trześniowe słody",
  "block.minecraft.cherry_trapdoor": "Trześniowo szłapa",
  "block.minecraft.cherry_wall_hanging_sign": "Trześniowy ściynny szild",
  "block.minecraft.cherry_wall_sign": "Trześniowy ściynny znak",
  "block.minecraft.cherry_wood": "Trześniowe drzewo",
  "block.minecraft.chest": "Kastla",
  "block.minecraft.chipped_anvil": "Uszczyrbiōny ambos",
  "block.minecraft.chiseled_bookshelf": "Wyrobiany bicherszrank",
  "block.minecraft.chiseled_copper": "Wyrobiano miydź",
  "block.minecraft.chiseled_deepslate": "Wyrobiany szyfer",
  "block.minecraft.chiseled_nether_bricks": "Wyrobiane netherowe cegły",
  "block.minecraft.chiseled_polished_blackstone": "Wyrobiany glancowany czorny kamiyń",
  "block.minecraft.chiseled_quartz_block": "Wyrobiany blok kwarcu",
  "block.minecraft.chiseled_red_sandstone": "Wyrobiany czyrwōny pioskowiec",
  "block.minecraft.chiseled_resin_bricks": "Wyrobiane żywicowe cegły",
  "block.minecraft.chiseled_sandstone": "Wyrobiany pioskowiec",
  "block.minecraft.chiseled_stone_bricks": "Wyrobiane kamiynne cegły",
  "block.minecraft.chiseled_tuff": "Wyrobiany tuf",
  "block.minecraft.chiseled_tuff_bricks": "Wyrobiane tufowe cegły",
  "block.minecraft.chorus_flower": "Kwiot refrynice",
  "block.minecraft.chorus_plant": "Refrynica",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zawrzito ślypioczka",
  "block.minecraft.coal_block": "Blok wōngla",
  "block.minecraft.coal_ore": "Erc wōngla",
  "block.minecraft.coarse_dirt": "Kamiynisto ziymia",
  "block.minecraft.cobbled_deepslate": "Szyfrowy floster",
  "block.minecraft.cobbled_deepslate_slab": "Szyfrowo flostrowo fliza",
  "block.minecraft.cobbled_deepslate_stairs": "Szyfrowe flostrowe słody",
  "block.minecraft.cobbled_deepslate_wall": "Szyfrowy flostrowy murek",
  "block.minecraft.cobblestone": "Floster",
  "block.minecraft.cobblestone_slab": "Flostrowo fliza",
  "block.minecraft.cobblestone_stairs": "Flostrowe słody",
  "block.minecraft.cobblestone_wall": "Flostrowy murek",
  "block.minecraft.cobweb": "Pajynczyna",
  "block.minecraft.cocoa": "Kakau",
  "block.minecraft.command_block": "Blok przikazōw",
  "block.minecraft.comparator": "Redstone’owy kōmparatōr",
  "block.minecraft.composter": "Kōmposter",
  "block.minecraft.conduit": "Lajtōng",
  "block.minecraft.copper_bars": "Miedzianno krota",
  "block.minecraft.copper_block": "Blok miedzi",
  "block.minecraft.copper_bulb": "Miedzianno byrna",
  "block.minecraft.copper_chain": "Miedzianno keta",
  "block.minecraft.copper_chest": "Miedzianno kastla",
  "block.minecraft.copper_door": "Miedzianne dźwiyrze",
  "block.minecraft.copper_golem_statue": "Posōng miedziannego golyma",
  "block.minecraft.copper_grate": "Miedzianne mrzeże",
  "block.minecraft.copper_lantern": "Miedzianno blyndka",
  "block.minecraft.copper_ore": "Erc miedzi",
  "block.minecraft.copper_torch": "Miedziowo fakla",
  "block.minecraft.copper_trapdoor": "Miedzianno szłapa",
  "block.minecraft.copper_wall_torch": "Ściynno miedziowo fakla",
  "block.minecraft.cornflower": "Faber",
  "block.minecraft.cracked_deepslate_bricks": "Pynknyte szyfrowe cegły",
  "block.minecraft.cracked_deepslate_tiles": "Pynknyte szyfrowe kachelki",
  "block.minecraft.cracked_nether_bricks": "Pynknyte netherowe cegły",
  "block.minecraft.cracked_polished_blackstone_bricks": "Pynknyte glancowane czornokamiynne cegły",
  "block.minecraft.cracked_stone_bricks": "Pynknyte kamiynne cegły",
  "block.minecraft.crafter": "Wytworzocz",
  "block.minecraft.crafting_table": "Fajlbank",
  "block.minecraft.creaking_heart": "Syrce grzipocza",
  "block.minecraft.creeper_head": "Gowa creepera",
  "block.minecraft.creeper_wall_head": "Ściynno gowa creepera",
  "block.minecraft.crimson_button": "Szarłatny knefel",
  "block.minecraft.crimson_door": "Szarłatne dźwiyrze",
  "block.minecraft.crimson_fence": "Szarłatny płot",
  "block.minecraft.crimson_fence_gate": "Szarłatno wrōtka",
  "block.minecraft.crimson_fungus": "Szarłatny grzib",
  "block.minecraft.crimson_hanging_sign": "Szarłatny szild",
  "block.minecraft.crimson_hyphae": "Szarłatne strzympki",
  "block.minecraft.crimson_nylium": "Szarłatny mycel",
  "block.minecraft.crimson_planks": "Szarłatne brety",
  "block.minecraft.crimson_pressure_plate": "Szarłatno drukplata",
  "block.minecraft.crimson_roots": "Szarłatne wōrcle",
  "block.minecraft.crimson_shelf": "Szarłatno pōłka",
  "block.minecraft.crimson_sign": "Szarłatny znak",
  "block.minecraft.crimson_slab": "Szarłatno fliza",
  "block.minecraft.crimson_stairs": "Szarłatne słody",
  "block.minecraft.crimson_stem": "Szarłatny sztil",
  "block.minecraft.crimson_trapdoor": "Szarłatno szłapa",
  "block.minecraft.crimson_wall_hanging_sign": "Szarłatny ściynny szild",
  "block.minecraft.crimson_wall_sign": "Szarłatny ściynny znak",
  "block.minecraft.crying_obsidian": "Płaczliwy ôbsydiōn",
  "block.minecraft.cut_copper": "Żłobiōno miydź",
  "block.minecraft.cut_copper_slab": "Żłobiōno miedzianno fliza",
  "block.minecraft.cut_copper_stairs": "Żłobiōne miedzianne słody",
  "block.minecraft.cut_red_sandstone": "Ciosany czyrwōny pioskowiec",
  "block.minecraft.cut_red_sandstone_slab": "Ciosano czyrwōno pioskowcowo fliza",
  "block.minecraft.cut_sandstone": "Ciosany pioskowiec",
  "block.minecraft.cut_sandstone_slab": "Ciosano pioskowcowo fliza",
  "block.minecraft.cyan_banner": "Cyjanowo fana",
  "block.minecraft.cyan_bed": "Cyjanowe łōżko",
  "block.minecraft.cyan_candle": "Cyjanowo świyczka",
  "block.minecraft.cyan_candle_cake": "Torta ze cyjanowōm świyczkōm",
  "block.minecraft.cyan_carpet": "Cyjanowy tepich",
  "block.minecraft.cyan_concrete": "Cyjanowy betōn",
  "block.minecraft.cyan_concrete_powder": "Cyjanowy cymynt",
  "block.minecraft.cyan_glazed_terracotta": "Cyjanowo glaziyrowano kamiōnka",
  "block.minecraft.cyan_shulker_box": "Cyjanowo shulkerowo kastla",
  "block.minecraft.cyan_stained_glass": "Cyjanowe szkło",
  "block.minecraft.cyan_stained_glass_pane": "Cyjanowo szklanno tofla",
  "block.minecraft.cyan_terracotta": "Cyjanowo kamiōnka",
  "block.minecraft.cyan_wool": "Cyjanowo wołna",
  "block.minecraft.damaged_anvil": "Popsowany ambos",
  "block.minecraft.dandelion": "Mlycz",
  "block.minecraft.dark_oak_button": "Ćmawodymbowy knefel",
  "block.minecraft.dark_oak_door": "Ćmawodymbowe dźwiyrze",
  "block.minecraft.dark_oak_fence": "Ćmawodymbowy płot",
  "block.minecraft.dark_oak_fence_gate": "Ćmawodymbowo wrōtka",
  "block.minecraft.dark_oak_hanging_sign": "Ćmawodymbowy szild",
  "block.minecraft.dark_oak_leaves": "Liście ćmawego dymbu",
  "block.minecraft.dark_oak_log": "Sztam ćmawego dymbu",
  "block.minecraft.dark_oak_planks": "Ćmawodymbowe brety",
  "block.minecraft.dark_oak_pressure_plate": "Ćmawodymbowo drukplata",
  "block.minecraft.dark_oak_sapling": "Flancka ćmawego dymbu",
  "block.minecraft.dark_oak_shelf": "Ćmawodymbowo pōłka",
  "block.minecraft.dark_oak_sign": "Ćmawodymbowy znak",
  "block.minecraft.dark_oak_slab": "Ćmawodymbowo fliza",
  "block.minecraft.dark_oak_stairs": "Ćmawodymbowe słody",
  "block.minecraft.dark_oak_trapdoor": "Ćmawodymbowo szłapa",
  "block.minecraft.dark_oak_wall_hanging_sign": "Ćmawodymbowy ściynny szild",
  "block.minecraft.dark_oak_wall_sign": "Ćmawodymbowy ściynny znak",
  "block.minecraft.dark_oak_wood": "Ćmawodymbowe drzewo",
  "block.minecraft.dark_prismarine": "Ćmawy prizmaryn",
  "block.minecraft.dark_prismarine_slab": "Ćmawoprizmarynowo fliza",
  "block.minecraft.dark_prismarine_stairs": "Ćmawoprizmarynowe słody",
  "block.minecraft.daylight_detector": "Czujnik dziynnego światła",
  "block.minecraft.dead_brain_coral": "Umrzity mōzgowy korol",
  "block.minecraft.dead_brain_coral_block": "Blok umrzitego mōzgowego korolu",
  "block.minecraft.dead_brain_coral_fan": "Umrzito mōzgowo gorgonia",
  "block.minecraft.dead_brain_coral_wall_fan": "Umrzito ściynno mōzgowo gorgonia",
  "block.minecraft.dead_bubble_coral": "Umrzity bōmbelkowy korol",
  "block.minecraft.dead_bubble_coral_block": "Blok umrzitego bōmbelkowego korolu",
  "block.minecraft.dead_bubble_coral_fan": "Umrzito bōmbelkowo gorgonia",
  "block.minecraft.dead_bubble_coral_wall_fan": "Umrzito ściynno bōmbelkowo gorgonia",
  "block.minecraft.dead_bush": "Uschnyty krzok",
  "block.minecraft.dead_fire_coral": "Umrzity ôgnisty korol",
  "block.minecraft.dead_fire_coral_block": "Blok umrzitego ôgnistego korolu",
  "block.minecraft.dead_fire_coral_fan": "Umrzito ôgnisto gorgonia",
  "block.minecraft.dead_fire_coral_wall_fan": "Umrzito ściynno ôgnisto gorgonia",
  "block.minecraft.dead_horn_coral": "Umrzity rogaty korol",
  "block.minecraft.dead_horn_coral_block": "Blok umrzitego rogatego korolu",
  "block.minecraft.dead_horn_coral_fan": "Umrzito rogato gorgonia",
  "block.minecraft.dead_horn_coral_wall_fan": "Umrzito ściynno rogato gorgonia",
  "block.minecraft.dead_tube_coral": "Umrzity rułkowy korol",
  "block.minecraft.dead_tube_coral_block": "Blok umrzitego rułkowego korolu",
  "block.minecraft.dead_tube_coral_fan": "Umrzito rułkowo gorgonia",
  "block.minecraft.dead_tube_coral_wall_fan": "Umrzito ściynno rułkowo gorgonia",
  "block.minecraft.decorated_pot": "Prziôzdobiōny bōnclok",
  "block.minecraft.deepslate": "Szyfer",
  "block.minecraft.deepslate_brick_slab": "Szyfrowo ceglanno fliza",
  "block.minecraft.deepslate_brick_stairs": "Szyfrowe ceglanne słody",
  "block.minecraft.deepslate_brick_wall": "Szyfrowy ceglanny murek",
  "block.minecraft.deepslate_bricks": "Szyfrowe cegły",
  "block.minecraft.deepslate_coal_ore": "Szyfrowy erc wōngla",
  "block.minecraft.deepslate_copper_ore": "Szyfrowy erc miedzi",
  "block.minecraft.deepslate_diamond_ore": "Szyfrowy erc dyjamyntu",
  "block.minecraft.deepslate_emerald_ore": "Szyfrowy erc szmaragdu",
  "block.minecraft.deepslate_gold_ore": "Szyfrowy erc złōta",
  "block.minecraft.deepslate_iron_ore": "Szyfrowy erc żelazła",
  "block.minecraft.deepslate_lapis_ore": "Szyfrowy erc lazurytu",
  "block.minecraft.deepslate_redstone_ore": "Szyfrowy erc redstone",
  "block.minecraft.deepslate_tile_slab": "Szyfrowo kachelkowo fliza",
  "block.minecraft.deepslate_tile_stairs": "Szyfrowe kachelkowe słody",
  "block.minecraft.deepslate_tile_wall": "Szyfrowy kachelkowy murek",
  "block.minecraft.deepslate_tiles": "Szyfrowe kachelki",
  "block.minecraft.detector_rail": "Glajzy ze synsorym",
  "block.minecraft.diamond_block": "Blok dyjamyntu",
  "block.minecraft.diamond_ore": "Erc dyjamyntu",
  "block.minecraft.diorite": "Dyjoryt",
  "block.minecraft.diorite_slab": "Dyjorytowo fliza",
  "block.minecraft.diorite_stairs": "Dyjorytowe słody",
  "block.minecraft.diorite_wall": "Dyjorytowy murek",
  "block.minecraft.dirt": "Ziymia",
  "block.minecraft.dirt_path": "Sztajg",
  "block.minecraft.dispenser": "Strzylocz",
  "block.minecraft.dragon_egg": "Drachowe jajco",
  "block.minecraft.dragon_head": "Gowa dracha",
  "block.minecraft.dragon_wall_head": "Ściynno gowa dracha",
  "block.minecraft.dried_ghast": "Wyschnyty ghast",
  "block.minecraft.dried_kelp_block": "Blok wysuszōnyj waserflance",
  "block.minecraft.dripstone_block": "Blok nacieku",
  "block.minecraft.dropper": "Podowocz",
  "block.minecraft.emerald_block": "Blok szmaragdu",
  "block.minecraft.emerald_ore": "Erc szmaragdu",
  "block.minecraft.enchanting_table": "Stōł zaklinocza",
  "block.minecraft.end_gateway": "Fōrta Endu",
  "block.minecraft.end_portal": "Portol Endu",
  "block.minecraft.end_portal_frame": "Rōma portolu Endu",
  "block.minecraft.end_rod": "Endowo ruta",
  "block.minecraft.end_stone": "Endowy kamiyń",
  "block.minecraft.end_stone_brick_slab": "Endowo kamiynno ceglanno fliza",
  "block.minecraft.end_stone_brick_stairs": "Endowe kamiynne ceglanne słody",
  "block.minecraft.end_stone_brick_wall": "Endowy kamiynny ceglanny murek",
  "block.minecraft.end_stone_bricks": "Endowe kamiynne cegły",
  "block.minecraft.ender_chest": "Kastla Endu",
  "block.minecraft.exposed_chiseled_copper": "Leko utlyniōno wyrobiano miydź",
  "block.minecraft.exposed_copper": "Leko utlyniōno miydź",
  "block.minecraft.exposed_copper_bars": "Leko utlyniōno miedzianno krota",
  "block.minecraft.exposed_copper_bulb": "Leko utlyniōno miedzianno byrna",
  "block.minecraft.exposed_copper_chain": "Leko utlyniōno miedzianno keta",
  "block.minecraft.exposed_copper_chest": "Leko utlyniōno miedzianno kastla",
  "block.minecraft.exposed_copper_door": "Leko utlyniōne miedzianne dźwiyrze",
  "block.minecraft.exposed_copper_golem_statue": "Leko utlyniōny posōng miedziannego golyma",
  "block.minecraft.exposed_copper_grate": "Leko utlyniōne miedzianne mrzeże",
  "block.minecraft.exposed_copper_lantern": "Leko utlyniōno miedzianno laterna",
  "block.minecraft.exposed_copper_trapdoor": "Leko utlyniōno miedzianno szłapa",
  "block.minecraft.exposed_cut_copper": "Leko utlyniōno żłobiōno miydź",
  "block.minecraft.exposed_cut_copper_slab": "Leko utlyniōno żłobiōno miedzianno fliza",
  "block.minecraft.exposed_cut_copper_stairs": "Leko utlyniōne żłobiōne miedzianne słody",
  "block.minecraft.exposed_lightning_rod": "Leko utlyniōny blicablajter",
  "block.minecraft.farmland": "Uprowno ziymia",
  "block.minecraft.fern": "Paprōć",
  "block.minecraft.fire": "Ôgyń",
  "block.minecraft.fire_coral": "Ôgnisty korol",
  "block.minecraft.fire_coral_block": "Blok ôgnistego korolu",
  "block.minecraft.fire_coral_fan": "Ôgnisto gorgonia",
  "block.minecraft.fire_coral_wall_fan": "Ściynno ôgnisto gorgonia",
  "block.minecraft.firefly_bush": "Jōnikowy krzok",
  "block.minecraft.fletching_table": "Stōł strzałorza",
  "block.minecraft.flower_pot": "Ôtka",
  "block.minecraft.flowering_azalea": "Kciōnco azalijo",
  "block.minecraft.flowering_azalea_leaves": "Liście kciōncyj azalije",
  "block.minecraft.frogspawn": "Rapitołzowe jajca",
  "block.minecraft.frosted_ice": "Ôszadlōny lōd",
  "block.minecraft.furnace": "Żeleźniok",
  "block.minecraft.gilded_blackstone": "Złocōny czorny kamiyń",
  "block.minecraft.glass": "Szkło",
  "block.minecraft.glass_pane": "Szklanno tofla",
  "block.minecraft.glow_lichen": "Blyndorost",
  "block.minecraft.glowstone": "Blyndok",
  "block.minecraft.gold_block": "Blok złōta",
  "block.minecraft.gold_ore": "Erc złōta",
  "block.minecraft.golden_dandelion": "Złōty mlycz",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitowo fliza",
  "block.minecraft.granite_stairs": "Granitowe słody",
  "block.minecraft.granite_wall": "Granitowy murek",
  "block.minecraft.grass": "Trowa",
  "block.minecraft.grass_block": "Blok trowy",
  "block.minecraft.gravel": "Kis",
  "block.minecraft.gray_banner": "Siwo fana",
  "block.minecraft.gray_bed": "Siwe łōżko",
  "block.minecraft.gray_candle": "Siwo świyczka",
  "block.minecraft.gray_candle_cake": "Torta ze siwōm świyczkōm",
  "block.minecraft.gray_carpet": "Siwy tepich",
  "block.minecraft.gray_concrete": "Siwy betōn",
  "block.minecraft.gray_concrete_powder": "Siwy cymynt",
  "block.minecraft.gray_glazed_terracotta": "Siwo glaziyrowano kamiōnka",
  "block.minecraft.gray_shulker_box": "Siwo shulkerowo kastla",
  "block.minecraft.gray_stained_glass": "Siwe szkło",
  "block.minecraft.gray_stained_glass_pane": "Siwo szklanno tofla",
  "block.minecraft.gray_terracotta": "Siwo kamiōnka",
  "block.minecraft.gray_wool": "Siwo wołna",
  "block.minecraft.green_banner": "Zielōno fana",
  "block.minecraft.green_bed": "Zielōne łōżko",
  "block.minecraft.green_candle": "Zielōno świyczka",
  "block.minecraft.green_candle_cake": "Torta ze zielōnōm świyczkōm",
  "block.minecraft.green_carpet": "Zielōny tepich",
  "block.minecraft.green_concrete": "Zielōny betōn",
  "block.minecraft.green_concrete_powder": "Zielōny cymynt",
  "block.minecraft.green_glazed_terracotta": "Zielōno glaziyrowano kamiōnka",
  "block.minecraft.green_shulker_box": "Zielōno shulkerowo kastla",
  "block.minecraft.green_stained_glass": "Zielōne szkło",
  "block.minecraft.green_stained_glass_pane": "Zielōno szklanno tofla",
  "block.minecraft.green_terracotta": "Zielōno kamiōnka",
  "block.minecraft.green_wool": "Zielōno wołna",
  "block.minecraft.grindstone": "Brusek",
  "block.minecraft.hanging_roots": "Wiszōnce wōrcle",
  "block.minecraft.hay_block": "Siober",
  "block.minecraft.heavy_core": "Ciynżki drzyń",
  "block.minecraft.heavy_weighted_pressure_plate": "Ciynżko wagowo drukplata",
  "block.minecraft.honey_block": "Blok miodu",
  "block.minecraft.honeycomb_block": "Blok ślyzykōw miodu",
  "block.minecraft.hopper": "Lyjok",
  "block.minecraft.horn_coral": "Rogaty korol",
  "block.minecraft.horn_coral_block": "Blok rogatego korolu",
  "block.minecraft.horn_coral_fan": "Rogato gorgonia",
  "block.minecraft.horn_coral_wall_fan": "Ściynno rogato gorgonia",
  "block.minecraft.ice": "Lōd",
  "block.minecraft.infested_chiseled_stone_bricks": "Chroboczywe wyrobiane kamiynne cegły",
  "block.minecraft.infested_cobblestone": "Chroboczywy floster",
  "block.minecraft.infested_cracked_stone_bricks": "Chroboczywe pynknyte kamiynne cegły",
  "block.minecraft.infested_deepslate": "Chroboczywy szyfer",
  "block.minecraft.infested_mossy_stone_bricks": "Chroboczywe zamszōne kamiynne cegły",
  "block.minecraft.infested_stone": "Chroboczywy kamiyń",
  "block.minecraft.infested_stone_bricks": "Chroboczywe kamiynne cegły",
  "block.minecraft.iron_bars": "Żelazno krota",
  "block.minecraft.iron_block": "Blok żelazła",
  "block.minecraft.iron_chain": "Żelazno keta",
  "block.minecraft.iron_door": "Żelazne dźwiyrze",
  "block.minecraft.iron_ore": "Erc żelazła",
  "block.minecraft.iron_trapdoor": "Żelazno szłapa",
  "block.minecraft.jack_o_lantern": "Świycōnco bania",
  "block.minecraft.jigsaw": "Kōnstrukcyjny blok",
  "block.minecraft.jukebox": "Platynszpiler",
  "block.minecraft.jungle_button": "Dżōnglowy knefel",
  "block.minecraft.jungle_door": "Dżōnglowe dźwiyrze",
  "block.minecraft.jungle_fence": "Dżōnglowy płot",
  "block.minecraft.jungle_fence_gate": "Dżōnglowo wrōtka",
  "block.minecraft.jungle_hanging_sign": "Dżōnglowy szild",
  "block.minecraft.jungle_leaves": "Liście dżōnglowego strōmu",
  "block.minecraft.jungle_log": "Sztam dżōnglowego strōmu",
  "block.minecraft.jungle_planks": "Dżōnglowe brety",
  "block.minecraft.jungle_pressure_plate": "Dżōnglowo drukplata",
  "block.minecraft.jungle_sapling": "Flancka dżōnglowego strōmu",
  "block.minecraft.jungle_shelf": "Dżōnglowo pōłka",
  "block.minecraft.jungle_sign": "Dżōnglowy znak",
  "block.minecraft.jungle_slab": "Dżōnglowo fliza",
  "block.minecraft.jungle_stairs": "Dżōnglowe słody",
  "block.minecraft.jungle_trapdoor": "Dżōnglowo szłapa",
  "block.minecraft.jungle_wall_hanging_sign": "Dżōnglowy ściynny szild",
  "block.minecraft.jungle_wall_sign": "Dżōnglowy ściynny znak",
  "block.minecraft.jungle_wood": "Dżōnglowe drzewo",
  "block.minecraft.kelp": "Waserflanca",
  "block.minecraft.kelp_plant": "Waserflanca",
  "block.minecraft.ladder": "Drabina",
  "block.minecraft.lantern": "Blyndka",
  "block.minecraft.lapis_block": "Blok lazurytu",
  "block.minecraft.lapis_ore": "Erc lazurytu",
  "block.minecraft.large_amethyst_bud": "Srogi pōnczek ametystu",
  "block.minecraft.large_fern": "Srogo paprōć",
  "block.minecraft.lava": "Lawa",
  "block.minecraft.lava_cauldron": "Kesel lawy",
  "block.minecraft.leaf_litter": "Liściowy ściyl",
  "block.minecraft.lectern": "Pult",
  "block.minecraft.lever": "Wajcha",
  "block.minecraft.light": "Światło",
  "block.minecraft.light_blue_banner": "Światłomodro fana",
  "block.minecraft.light_blue_bed": "Światłomodre łōżko",
  "block.minecraft.light_blue_candle": "Światłomodro świyczka",
  "block.minecraft.light_blue_candle_cake": "Torta ze światłomodrōm świyczkōm",
  "block.minecraft.light_blue_carpet": "Światłomodry tepich",
  "block.minecraft.light_blue_concrete": "Światłomodry betōn",
  "block.minecraft.light_blue_concrete_powder": "Światłomodry cymynt",
  "block.minecraft.light_blue_glazed_terracotta": "Światłomodro glaziyrowano kamiōnka",
  "block.minecraft.light_blue_shulker_box": "Światłomodro shulkerowo kastla",
  "block.minecraft.light_blue_stained_glass": "Światłomodre szkło",
  "block.minecraft.light_blue_stained_glass_pane": "Światłomodro szklanno tofla",
  "block.minecraft.light_blue_terracotta": "Światłomodro kamiōnka",
  "block.minecraft.light_blue_wool": "Światłomodro wołna",
  "block.minecraft.light_gray_banner": "Światłosiwo fana",
  "block.minecraft.light_gray_bed": "Światłosiwe łōżko",
  "block.minecraft.light_gray_candle": "Światłosiwo świyczka",
  "block.minecraft.light_gray_candle_cake": "Torta ze światłosiwōm świyczkōm",
  "block.minecraft.light_gray_carpet": "Światłosiwy tepich",
  "block.minecraft.light_gray_concrete": "Światłosiwy betōn",
  "block.minecraft.light_gray_concrete_powder": "Światłosiwy cymynt",
  "block.minecraft.light_gray_glazed_terracotta": "Światłosiwo glaziyrowano kamiōnka",
  "block.minecraft.light_gray_shulker_box": "Światłosiwo shulkerowo kastla",
  "block.minecraft.light_gray_stained_glass": "Światłosiwe szkło",
  "block.minecraft.light_gray_stained_glass_pane": "Światłosiwo szklanno tofla",
  "block.minecraft.light_gray_terracotta": "Światłosiwo kamiōnka",
  "block.minecraft.light_gray_wool": "Światłosiwo wołna",
  "block.minecraft.light_weighted_pressure_plate": "Leko wagowo drukplata",
  "block.minecraft.lightning_rod": "Blicablajter",
  "block.minecraft.lilac": "Bez",
  "block.minecraft.lily_of_the_valley": "Majglokla",
  "block.minecraft.lily_pad": "Wodno lilijo",
  "block.minecraft.lime_banner": "Limōnkowo fana",
  "block.minecraft.lime_bed": "Limōnkowe łōżko",
  "block.minecraft.lime_candle": "Limōnkowo świyczka",
  "block.minecraft.lime_candle_cake": "Torta ze limōnkowōm świyczkōm",
  "block.minecraft.lime_carpet": "Limōnkowy tepich",
  "block.minecraft.lime_concrete": "Limōnkowy betōn",
  "block.minecraft.lime_concrete_powder": "Limōnkowy cymynt",
  "block.minecraft.lime_glazed_terracotta": "Limōnkowo glaziyrowano kamiōnka",
  "block.minecraft.lime_shulker_box": "Limōnkowo shulkerowo kastla",
  "block.minecraft.lime_stained_glass": "Limōnkowe szkło",
  "block.minecraft.lime_stained_glass_pane": "Limōnkowo szklanno tofla",
  "block.minecraft.lime_terracotta": "Limōnkowo kamiōnka",
  "block.minecraft.lime_wool": "Limōnkowo wołna",
  "block.minecraft.lodestone": "Magnetyt",
  "block.minecraft.loom": "Krosna",
  "block.minecraft.magenta_banner": "Purpurowo fana",
  "block.minecraft.magenta_bed": "Purpurowe łōżko",
  "block.minecraft.magenta_candle": "Purpurowo świyczka",
  "block.minecraft.magenta_candle_cake": "Torta ze purpurowōm świyczkōm",
  "block.minecraft.magenta_carpet": "Purpurowy tepich",
  "block.minecraft.magenta_concrete": "Purpurowy betōn",
  "block.minecraft.magenta_concrete_powder": "Purpurowy cymynt",
  "block.minecraft.magenta_glazed_terracotta": "Purpurowo glaziyrowano kamiōnka",
  "block.minecraft.magenta_shulker_box": "Purpurowo shulkerowo kastla",
  "block.minecraft.magenta_stained_glass": "Purpurowe szkło",
  "block.minecraft.magenta_stained_glass_pane": "Purpurowo szklanno tofla",
  "block.minecraft.magenta_terracotta": "Purpurowo kamiōnka",
  "block.minecraft.magenta_wool": "Purpurowo wołna",
  "block.minecraft.magma_block": "Blok magmy",
  "block.minecraft.mangrove_button": "Namorzinowy knefel",
  "block.minecraft.mangrove_door": "Namorzinowe dźwiyrze",
  "block.minecraft.mangrove_fence": "Namorzinowy płot",
  "block.minecraft.mangrove_fence_gate": "Namorzinowo wrōtka",
  "block.minecraft.mangrove_hanging_sign": "Namorzinowy szild",
  "block.minecraft.mangrove_leaves": "Liście namorzinōw",
  "block.minecraft.mangrove_log": "Sztam namorzinu",
  "block.minecraft.mangrove_planks": "Namorzinowe brety",
  "block.minecraft.mangrove_pressure_plate": "Namorzinowo drukplata",
  "block.minecraft.mangrove_propagule": "Rozsad namorzinu",
  "block.minecraft.mangrove_roots": "Namorzinowe wōrcle",
  "block.minecraft.mangrove_shelf": "Namorzinowo pōłka",
  "block.minecraft.mangrove_sign": "Namorzinowy znak",
  "block.minecraft.mangrove_slab": "Namorzinowo fliza",
  "block.minecraft.mangrove_stairs": "Namorzinowe słody",
  "block.minecraft.mangrove_trapdoor": "Namorzinowo szłapa",
  "block.minecraft.mangrove_wall_hanging_sign": "Namorzinowy ściynny szild",
  "block.minecraft.mangrove_wall_sign": "Namorzinowy ściynny znak",
  "block.minecraft.mangrove_wood": "Namorzinowe drzewo",
  "block.minecraft.medium_amethyst_bud": "Strzedni pōnczek ametystu",
  "block.minecraft.melon": "Wasermelōn",
  "block.minecraft.melon_stem": "Sztyngel wasermelōna",
  "block.minecraft.moss_block": "Blok mchu",
  "block.minecraft.moss_carpet": "Szlichta mchu",
  "block.minecraft.mossy_cobblestone": "Zamszōny floster",
  "block.minecraft.mossy_cobblestone_slab": "Zamszōno flostrowo fliza",
  "block.minecraft.mossy_cobblestone_stairs": "Zamszōne flostrowe słody",
  "block.minecraft.mossy_cobblestone_wall": "Zamszōny flostrowy murek",
  "block.minecraft.mossy_stone_brick_slab": "Zamszōno kamiynno ceglanno fliza ",
  "block.minecraft.mossy_stone_brick_stairs": "Zamszōne kamiynne ceglanne słody",
  "block.minecraft.mossy_stone_brick_wall": "Zamszōny kamiynny ceglanny murek",
  "block.minecraft.mossy_stone_bricks": "Zamszōne kamiynne cegły",
  "block.minecraft.moving_piston": "Tłok we gangu",
  "block.minecraft.mud": "Ciaplyta",
  "block.minecraft.mud_brick_slab": "Ciaplato ceglanno fliza",
  "block.minecraft.mud_brick_stairs": "Ciaplate ceglanne słody",
  "block.minecraft.mud_brick_wall": "Ciaplaty ceglanny murek",
  "block.minecraft.mud_bricks": "Ciaplate cegły",
  "block.minecraft.muddy_mangrove_roots": "Ciaplate wōrcle namorzinu",
  "block.minecraft.mushroom_stem": "Sztil grziba",
  "block.minecraft.mycelium": "Mycel",
  "block.minecraft.nether_brick_fence": "Netherowy ceglanny płot",
  "block.minecraft.nether_brick_slab": "Netherowo ceglanno fliza",
  "block.minecraft.nether_brick_stairs": "Netherowe ceglanne słody",
  "block.minecraft.nether_brick_wall": "Netherowy ceglanny murek",
  "block.minecraft.nether_bricks": "Netherowe cegły",
  "block.minecraft.nether_gold_ore": "Netherowy erc złōta",
  "block.minecraft.nether_portal": "Netherowy portol",
  "block.minecraft.nether_quartz_ore": "Erc netherowego kwarcu",
  "block.minecraft.nether_sprouts": "Netherowe rywiki",
  "block.minecraft.nether_wart": "Netherowo kurzowka",
  "block.minecraft.nether_wart_block": "Blok netherowyj kurzowki",
  "block.minecraft.netherite_block": "Blok netherytu",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Klangblok",
  "block.minecraft.oak_button": "Dymbowy knefel",
  "block.minecraft.oak_door": "Dymbowe dźwiyrze",
  "block.minecraft.oak_fence": "Dymbowy płot",
  "block.minecraft.oak_fence_gate": "Dymbowo wrōtka",
  "block.minecraft.oak_hanging_sign": "Dymbowy szild",
  "block.minecraft.oak_leaves": "Liście dymbu",
  "block.minecraft.oak_log": "Sztam dymbu",
  "block.minecraft.oak_planks": "Dymbowe brety",
  "block.minecraft.oak_pressure_plate": "Dymbowo drukplata",
  "block.minecraft.oak_sapling": "Flancka dymbu",
  "block.minecraft.oak_shelf": "Dymbowo pōłka",
  "block.minecraft.oak_sign": "Dymbowy znak",
  "block.minecraft.oak_slab": "Dymbowo fliza",
  "block.minecraft.oak_stairs": "Dymbowe słody",
  "block.minecraft.oak_trapdoor": "Dymbowo szłapa",
  "block.minecraft.oak_wall_hanging_sign": "Dymbowy ściynny szild",
  "block.minecraft.oak_wall_sign": "Dymbowy ściynny znak",
  "block.minecraft.oak_wood": "Dymbowe drzewo",
  "block.minecraft.observer": "Spoziyrocz",
  "block.minecraft.obsidian": "Ôbsydiōn",
  "block.minecraft.ochre_froglight": "Ôkrowo blyndołza",
  "block.minecraft.ominous_banner": "Lagramyncko fana",
  "block.minecraft.open_eyeblossom": "Ôdewrzito ślypioczka",
  "block.minecraft.orange_banner": "Ôranżowo fana",
  "block.minecraft.orange_bed": "Ôranżowe łōżko",
  "block.minecraft.orange_candle": "Ôranżowo świyczka",
  "block.minecraft.orange_candle_cake": "Torta ze ôranżowōm świyczkōm",
  "block.minecraft.orange_carpet": "Ôranżowy tepich",
  "block.minecraft.orange_concrete": "Ôranżowy betōn",
  "block.minecraft.orange_concrete_powder": "Ôranżowy cymynt",
  "block.minecraft.orange_glazed_terracotta": "Ôranżowo glaziyrowano kamiōnka",
  "block.minecraft.orange_shulker_box": "Ôranżowo shulkerowo kastla",
  "block.minecraft.orange_stained_glass": "Ôranżowe szkło",
  "block.minecraft.orange_stained_glass_pane": "Ôranżowo szklanno tofla",
  "block.minecraft.orange_terracotta": "Ôranżowo kamiōnka",
  "block.minecraft.orange_tulip": "Ôranżowo tulpa",
  "block.minecraft.orange_wool": "Ôranżowo wołna",
  "block.minecraft.oxeye_daisy": "Gyńsipympek",
  "block.minecraft.oxidized_chiseled_copper": "Utlyniōno wyrobiano miydź",
  "block.minecraft.oxidized_copper": "Utlyniōno miydź",
  "block.minecraft.oxidized_copper_bars": "Utlyniōno miedzianno krota",
  "block.minecraft.oxidized_copper_bulb": "Utlyniōno miedzianno byrna",
  "block.minecraft.oxidized_copper_chain": "Utlyniōno miedzianno keta",
  "block.minecraft.oxidized_copper_chest": "Utlyniōno miedzianno kastla",
  "block.minecraft.oxidized_copper_door": "Utlyniōne miedzianne dźwiyrze",
  "block.minecraft.oxidized_copper_golem_statue": "Utlyniōny posōng miedziannego golyma",
  "block.minecraft.oxidized_copper_grate": "Utlyniōne miedzianne mrzeże",
  "block.minecraft.oxidized_copper_lantern": "Utlyniōno miedzianno laterna",
  "block.minecraft.oxidized_copper_trapdoor": "Utlyniōno miedzianno szłapa",
  "block.minecraft.oxidized_cut_copper": "Utlyniōno żłobiōno miydź",
  "block.minecraft.oxidized_cut_copper_slab": "Utlyniōno żłobiōno miedzianno fliza",
  "block.minecraft.oxidized_cut_copper_stairs": "Utlyniōne żłobiōne miedzianne słody",
  "block.minecraft.oxidized_lightning_rod": "Utlyniōny blicablajter",
  "block.minecraft.packed_ice": "Zewarty lōd",
  "block.minecraft.packed_mud": "Zewarto ciaplyta",
  "block.minecraft.pale_hanging_moss": "Wiszōncy blady mech",
  "block.minecraft.pale_moss_block": "Blok bladego mchu",
  "block.minecraft.pale_moss_carpet": "Szlichta bladego mchu",
  "block.minecraft.pale_oak_button": "Bladodymbowy knefel",
  "block.minecraft.pale_oak_door": "Bladodymbowe dźwiyrze",
  "block.minecraft.pale_oak_fence": "Bladodymbowy płot",
  "block.minecraft.pale_oak_fence_gate": "Bladodymbowo wrōtka",
  "block.minecraft.pale_oak_hanging_sign": "Bladodymbowy szild",
  "block.minecraft.pale_oak_leaves": "Liście bladego dymbu",
  "block.minecraft.pale_oak_log": "Sztam bladego dymbu",
  "block.minecraft.pale_oak_planks": "Bladodymbowe brety",
  "block.minecraft.pale_oak_pressure_plate": "Bladodymbowo drukplata",
  "block.minecraft.pale_oak_sapling": "Flancka bladego dymbu",
  "block.minecraft.pale_oak_shelf": "Bladodymbowo pōłka",
  "block.minecraft.pale_oak_sign": "Bladodymbowy znak",
  "block.minecraft.pale_oak_slab": "Bladodymbowo fliza",
  "block.minecraft.pale_oak_stairs": "Bladodymbowe słody",
  "block.minecraft.pale_oak_trapdoor": "Bladodymbowo szłapa",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bladodymbowy ściynny szild",
  "block.minecraft.pale_oak_wall_sign": "Bladodymbowy ściynny znak",
  "block.minecraft.pale_oak_wood": "Bladodymbowe drzewo",
  "block.minecraft.pearlescent_froglight": "Perlowo blyndołza",
  "block.minecraft.peony": "Piwowōnijo",
  "block.minecraft.petrified_oak_slab": "Skamiyniało dymbowo fliza",
  "block.minecraft.piglin_head": "Gowa piglina",
  "block.minecraft.piglin_wall_head": "Ściynno gowa piglina",
  "block.minecraft.pink_banner": "Rōżowo fana",
  "block.minecraft.pink_bed": "Rōżowe łōżko",
  "block.minecraft.pink_candle": "Rōżowo świyczka",
  "block.minecraft.pink_candle_cake": "Torta ze rōżowōm świyczkōm",
  "block.minecraft.pink_carpet": "Rōżowy tepich",
  "block.minecraft.pink_concrete": "Rōżowy betōn",
  "block.minecraft.pink_concrete_powder": "Rōżowy cymynt",
  "block.minecraft.pink_glazed_terracotta": "Rōżowo glaziyrowano kamiōnka",
  "block.minecraft.pink_petals": "Rōżowe krōnblaty",
  "block.minecraft.pink_shulker_box": "Rōżowo shulkerowo kastla",
  "block.minecraft.pink_stained_glass": "Rōżowe szkło",
  "block.minecraft.pink_stained_glass_pane": "Rōżowo szklanno tofla",
  "block.minecraft.pink_terracotta": "Rōżowo kamiōnka",
  "block.minecraft.pink_tulip": "Rōżowo tulpa",
  "block.minecraft.pink_wool": "Rōżowo wołna",
  "block.minecraft.piston": "Tłok",
  "block.minecraft.piston_head": "Gōwica tłoka",
  "block.minecraft.pitcher_crop": "Zbōnecznik",
  "block.minecraft.pitcher_plant": "Zbōnecznik",
  "block.minecraft.player_head": "Gowa grocza",
  "block.minecraft.player_head.named": "Gowa grocza „%s”",
  "block.minecraft.player_wall_head": "Ściynno gowa grocza",
  "block.minecraft.podzol": "Biylica",
  "block.minecraft.pointed_dripstone": "Szpicaty naciek",
  "block.minecraft.polished_andesite": "Glancowany andezit",
  "block.minecraft.polished_andesite_slab": "Glancowano andezitowo fliza",
  "block.minecraft.polished_andesite_stairs": "Glancowane andezitowe słody",
  "block.minecraft.polished_basalt": "Glancowany bazalt",
  "block.minecraft.polished_blackstone": "Glancowany czorny kamiyń",
  "block.minecraft.polished_blackstone_brick_slab": "Glancowano czornokamiynno ceglanno fliza",
  "block.minecraft.polished_blackstone_brick_stairs": "Glancowane czornokamiynne ceglanne słody",
  "block.minecraft.polished_blackstone_brick_wall": "Glancowany czornokamiynny ceglanny murek",
  "block.minecraft.polished_blackstone_bricks": "Glancowane czornokamiynne cegły",
  "block.minecraft.polished_blackstone_button": "Glancowany czornokamiynny knefel",
  "block.minecraft.polished_blackstone_pressure_plate": "Glancowano czornokamiynno drukplata",
  "block.minecraft.polished_blackstone_slab": "Glancowano czornokamiynno fliza",
  "block.minecraft.polished_blackstone_stairs": "Glancowane czornokamiynne słody",
  "block.minecraft.polished_blackstone_wall": "Glancowany czornokamiynny murek",
  "block.minecraft.polished_deepslate": "Glancowany szyfer",
  "block.minecraft.polished_deepslate_slab": "Glancowano szyfrowo fliza",
  "block.minecraft.polished_deepslate_stairs": "Glancowane szyfrowe słody",
  "block.minecraft.polished_deepslate_wall": "Glancowany szyfrowy murek",
  "block.minecraft.polished_diorite": "Glancowany dyjoryt",
  "block.minecraft.polished_diorite_slab": "Glancowano dyjorytowo fliza",
  "block.minecraft.polished_diorite_stairs": "Glancowane dyjorytowe słody",
  "block.minecraft.polished_granite": "Glancowany granit",
  "block.minecraft.polished_granite_slab": "Glancowano granitowo fliza",
  "block.minecraft.polished_granite_stairs": "Glancowane granitowe słody",
  "block.minecraft.polished_tuff": "Glancowany tuf",
  "block.minecraft.polished_tuff_slab": "Glancowano tufowo fliza",
  "block.minecraft.polished_tuff_stairs": "Glancowane tufowe słody",
  "block.minecraft.polished_tuff_wall": "Glancowany tufowy murek",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Kartofle",
  "block.minecraft.potted_acacia_sapling": "Flancka agacu we ôtce",
  "block.minecraft.potted_allium": "Knobloch we ôtce",
  "block.minecraft.potted_azalea_bush": "Azalijo we ôtce",
  "block.minecraft.potted_azure_bluet": "Lazurowo hiustōnijo we ôtce",
  "block.minecraft.potted_bamboo": "Bambus we ôtce",
  "block.minecraft.potted_birch_sapling": "Flancka brzizki we ôtce",
  "block.minecraft.potted_blue_orchid": "Modry storczyk we ôtce",
  "block.minecraft.potted_brown_mushroom": "Prawok we ôtce",
  "block.minecraft.potted_cactus": "Kaktus we ôtce",
  "block.minecraft.potted_cherry_sapling": "Flancka trześnie we ôtce",
  "block.minecraft.potted_closed_eyeblossom": "Zawrzito ślypioczka we ôtce",
  "block.minecraft.potted_cornflower": "Faber we ôtce",
  "block.minecraft.potted_crimson_fungus": "Szarłatny grzib we ôtce",
  "block.minecraft.potted_crimson_roots": "Szarłatne wōrcle we ôtce",
  "block.minecraft.potted_dandelion": "Mlycz we ôtce",
  "block.minecraft.potted_dark_oak_sapling": "Flancka ćmawego dymbu we ôtce",
  "block.minecraft.potted_dead_bush": "Uschnyty krzok we ôtce",
  "block.minecraft.potted_fern": "Paprōć we ôtce",
  "block.minecraft.potted_flowering_azalea_bush": "Kciōnco azalijo we ôtce",
  "block.minecraft.potted_golden_dandelion": "Złōty mlycz we ôtce",
  "block.minecraft.potted_jungle_sapling": "Flancka dżōnglowego strōmu we ôtce",
  "block.minecraft.potted_lily_of_the_valley": "Majglokla we ôtce",
  "block.minecraft.potted_mangrove_propagule": "Rozsad namorzinu we ôtce",
  "block.minecraft.potted_oak_sapling": "Flancka dymbu we ôtce",
  "block.minecraft.potted_open_eyeblossom": "Ôdewrzito ślypioczka we ôtce",
  "block.minecraft.potted_orange_tulip": "Ôranżowo tulpa we ôtce",
  "block.minecraft.potted_oxeye_daisy": "Gyńsipympek we ôtce",
  "block.minecraft.potted_pale_oak_sapling": "Flancka bladego dymbu we ôtce",
  "block.minecraft.potted_pink_tulip": "Rōżowo tulpa we ôtce",
  "block.minecraft.potted_poppy": "Mak we ôtce",
  "block.minecraft.potted_red_mushroom": "Muszok we ôtce",
  "block.minecraft.potted_red_tulip": "Czyrwōno tulpa we ôtce",
  "block.minecraft.potted_spruce_sapling": "Flancka świyrku we ôtce",
  "block.minecraft.potted_torchflower": "Fakliczka we ôtce",
  "block.minecraft.potted_warped_fungus": "Szagi grzib we ôtce",
  "block.minecraft.potted_warped_roots": "Szage wōrcle we ôtce",
  "block.minecraft.potted_white_tulip": "Bioło tulpa we ôtce",
  "block.minecraft.potted_wither_rose": "Witherrōłza we ôtce",
  "block.minecraft.powder_snow": "Sypki śniyg",
  "block.minecraft.powder_snow_cauldron": "Kesel sypkego śniega",
  "block.minecraft.powered_rail": "Napyndzane glajzy",
  "block.minecraft.prismarine": "Prizmaryn",
  "block.minecraft.prismarine_brick_slab": "Prizmarinowo ceglanno fliza",
  "block.minecraft.prismarine_brick_stairs": "Prizmarynowe ceglanne słody",
  "block.minecraft.prismarine_bricks": "Prizmarynowe cegły",
  "block.minecraft.prismarine_slab": "Prizmarinowo fliza",
  "block.minecraft.prismarine_stairs": "Prizmarynowe słody",
  "block.minecraft.prismarine_wall": "Prizmarynowy murek",
  "block.minecraft.pumpkin": "Bania",
  "block.minecraft.pumpkin_stem": "Sztyngel banie",
  "block.minecraft.purple_banner": "Flidrowo fana",
  "block.minecraft.purple_bed": "Flidrowe łōżko",
  "block.minecraft.purple_candle": "Flidrowo świyczka",
  "block.minecraft.purple_candle_cake": "Torta ze flidrowōm świyczkōm",
  "block.minecraft.purple_carpet": "Flidrowy tepich",
  "block.minecraft.purple_concrete": "Flidrowy betōn",
  "block.minecraft.purple_concrete_powder": "Flidrowy cymynt",
  "block.minecraft.purple_glazed_terracotta": "Flidrowo glaziyrowano kamiōnka",
  "block.minecraft.purple_shulker_box": "Flidrowo shulkerowo kastla",
  "block.minecraft.purple_stained_glass": "Flidrowe szkło",
  "block.minecraft.purple_stained_glass_pane": "Flidrowo szklanno tofla",
  "block.minecraft.purple_terracotta": "Flidrowo kamiōnka",
  "block.minecraft.purple_wool": "Flidrowo wołna",
  "block.minecraft.purpur_block": "Blok purpury",
  "block.minecraft.purpur_pillar": "Purpurowy filor",
  "block.minecraft.purpur_slab": "Purpurowo fliza",
  "block.minecraft.purpur_stairs": "Purpurowe słody",
  "block.minecraft.quartz_block": "Blok kwarcu",
  "block.minecraft.quartz_bricks": "Kwarcowe cegły",
  "block.minecraft.quartz_pillar": "Kwarcowy filor",
  "block.minecraft.quartz_slab": "Kwarcowo fliza",
  "block.minecraft.quartz_stairs": "Kwarcowe słody",
  "block.minecraft.rail": "Glajzy",
  "block.minecraft.raw_copper_block": "Blok surowyj miedzi",
  "block.minecraft.raw_gold_block": "Blok surowego złōta",
  "block.minecraft.raw_iron_block": "Blok surowego żelazła",
  "block.minecraft.red_banner": "Czyrwōno fana",
  "block.minecraft.red_bed": "Czyrwōne łōżko",
  "block.minecraft.red_candle": "Czyrwōno świyczka",
  "block.minecraft.red_candle_cake": "Torta ze czyrwōnōm świyczkōm",
  "block.minecraft.red_carpet": "Czyrwōny tepich",
  "block.minecraft.red_concrete": "Czyrwōny betōn",
  "block.minecraft.red_concrete_powder": "Czyrwōny cymynt",
  "block.minecraft.red_glazed_terracotta": "Czyrwōno glaziyrowano kamiōnka",
  "block.minecraft.red_mushroom": "Muszok",
  "block.minecraft.red_mushroom_block": "Blok muszoka",
  "block.minecraft.red_nether_brick_slab": "Czyrwōno netherowo ceglanno fliza",
  "block.minecraft.red_nether_brick_stairs": "Czyrwōne netherowe ceglanne słody",
  "block.minecraft.red_nether_brick_wall": "Czyrwōny netherowy ceglanny murek",
  "block.minecraft.red_nether_bricks": "Czyrwōne netherowe cegły",
  "block.minecraft.red_sand": "Czyrwōny piosek",
  "block.minecraft.red_sandstone": "Czyrwōny pioskowiec",
  "block.minecraft.red_sandstone_slab": "Czyrwōno pioskowcowo fliza",
  "block.minecraft.red_sandstone_stairs": "Czyrwōne pioskowcowe słody",
  "block.minecraft.red_sandstone_wall": "Czyrwōny pioskowcowy murek",
  "block.minecraft.red_shulker_box": "Czyrwōno shulkerowo kastla",
  "block.minecraft.red_stained_glass": "Czyrwōne szkło",
  "block.minecraft.red_stained_glass_pane": "Czyrwōno szklanno tofla",
  "block.minecraft.red_terracotta": "Czyrwōno kamiōnka",
  "block.minecraft.red_tulip": "Czyrwōno tulpa",
  "block.minecraft.red_wool": "Czyrwōno wołna",
  "block.minecraft.redstone_block": "Blok redstone",
  "block.minecraft.redstone_lamp": "Redstone’owo lampa",
  "block.minecraft.redstone_ore": "Erc redstone",
  "block.minecraft.redstone_torch": "Redstone’owo fakla",
  "block.minecraft.redstone_wall_torch": "Ściynno redstone’owo fakla",
  "block.minecraft.redstone_wire": "Redstone’owy przewōd",
  "block.minecraft.reinforced_deepslate": "Zbrojōny szyfer",
  "block.minecraft.repeater": "Redstone’owy przekoźnik",
  "block.minecraft.repeating_command_block": "Powtorzajōncy blok przikazōw",
  "block.minecraft.resin_block": "Blok żywicy",
  "block.minecraft.resin_brick_slab": "Żywicowo ceglanno fliza",
  "block.minecraft.resin_brick_stairs": "Żywicowe ceglanne słody",
  "block.minecraft.resin_brick_wall": "Żywicowy ceglanny murek",
  "block.minecraft.resin_bricks": "Żywicowe cegły",
  "block.minecraft.resin_clump": "Chłopeć żywicy",
  "block.minecraft.respawn_anchor": "Anker ôdrodzynio",
  "block.minecraft.rooted_dirt": "Wōrclato ziymia",
  "block.minecraft.rose_bush": "Rōłzowy krzok",
  "block.minecraft.sand": "Piosek",
  "block.minecraft.sandstone": "Pioskowiec",
  "block.minecraft.sandstone_slab": "Pioskowcowo fliza",
  "block.minecraft.sandstone_stairs": "Pioskowcowe słody",
  "block.minecraft.sandstone_wall": "Pioskowcowy murek",
  "block.minecraft.scaffolding": "Rysztōnek",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkowy katalizatōr",
  "block.minecraft.sculk_sensor": "Sculkowy synsōr",
  "block.minecraft.sculk_shrieker": "Sculkowy krzykocz",
  "block.minecraft.sculk_vein": "Sculkowo żyła",
  "block.minecraft.sea_lantern": "Morsko laterna",
  "block.minecraft.sea_pickle": "Morski ôgōrek",
  "block.minecraft.seagrass": "Morsko trowa",
  "block.minecraft.set_spawn": "Nasztalowano pōnkt ôdrodzanio",
  "block.minecraft.short_dry_grass": "Nizko sucho trowa",
  "block.minecraft.short_grass": "Nizko trowa",
  "block.minecraft.shroomlight": "Blyndogrzib",
  "block.minecraft.shulker_box": "Shulkerowo kastla",
  "block.minecraft.skeleton_skull": "Szala szkeleta",
  "block.minecraft.skeleton_wall_skull": "Ściynno szala szkeleta",
  "block.minecraft.slime_block": "Blok szlōmu",
  "block.minecraft.small_amethyst_bud": "Mały pōnczek ametystu",
  "block.minecraft.small_dripleaf": "Mały czampiōnek",
  "block.minecraft.smithing_table": "Stōł kowola",
  "block.minecraft.smoker": "Wyndzok",
  "block.minecraft.smooth_basalt": "Glajchowany bazalt",
  "block.minecraft.smooth_quartz": "Glajchowany blok kwarcu",
  "block.minecraft.smooth_quartz_slab": "Glajchowano kwarcowo fliza",
  "block.minecraft.smooth_quartz_stairs": "Glajchowane kwarcowe słody",
  "block.minecraft.smooth_red_sandstone": "Glajchowany czyrwōny pioskowiec",
  "block.minecraft.smooth_red_sandstone_slab": "Glajchowano czyrwōno pioskowcowo fliza",
  "block.minecraft.smooth_red_sandstone_stairs": "Glajchowane czyrwōne pioskowcowe słody",
  "block.minecraft.smooth_sandstone": "Glajchowany pioskowiec",
  "block.minecraft.smooth_sandstone_slab": "Glajchowano pioskowcowo fliza",
  "block.minecraft.smooth_sandstone_stairs": "Glajchowane pioskowcowe słody",
  "block.minecraft.smooth_stone": "Glajchowany kamiyń",
  "block.minecraft.smooth_stone_slab": "Glajchowano kamiynno fliza",
  "block.minecraft.sniffer_egg": "Jajco sznupocza",
  "block.minecraft.snow": "Śniyg",
  "block.minecraft.snow_block": "Blok śniega",
  "block.minecraft.soul_campfire": "Duszyczkowo fojera",
  "block.minecraft.soul_fire": "Duszyczkowy ôgyń",
  "block.minecraft.soul_lantern": "Duszyczkowo blyndka",
  "block.minecraft.soul_sand": "Duszyczkowy piosek",
  "block.minecraft.soul_soil": "Duszyczkowo ziymia",
  "block.minecraft.soul_torch": "Duszyczkowo fakla",
  "block.minecraft.soul_wall_torch": "Ściynno duszyczkowo fakla",
  "block.minecraft.spawn.not_valid": "Niy mosz przidzielōnego łōżka ani ankry ôdrodzynio, abo bōły zagrodzōne",
  "block.minecraft.spawner": "Swoływocz bebokōw",
  "block.minecraft.spawner.desc1": "Interakcyjo ze jajcym:",
  "block.minecraft.spawner.desc2": "Ustowio zorta stworzynio",
  "block.minecraft.sponge": "Gōmbka",
  "block.minecraft.spore_blossom": "Fukōwka",
  "block.minecraft.spruce_button": "Świyrkowy knefel",
  "block.minecraft.spruce_door": "Świyrkowe dźwiyrze",
  "block.minecraft.spruce_fence": "Świyrkowy płot",
  "block.minecraft.spruce_fence_gate": "Świyrkowo wōrtka",
  "block.minecraft.spruce_hanging_sign": "Świyrkowy szild",
  "block.minecraft.spruce_leaves": "Liście świyrku",
  "block.minecraft.spruce_log": "Sztam świyrku",
  "block.minecraft.spruce_planks": "Świyrkowe brety",
  "block.minecraft.spruce_pressure_plate": "Świyrkowo drukplata",
  "block.minecraft.spruce_sapling": "Flancka świyrku",
  "block.minecraft.spruce_shelf": "Świyrkowo pōłka",
  "block.minecraft.spruce_sign": "Świyrkowy znak",
  "block.minecraft.spruce_slab": "Świyrkowo fliza",
  "block.minecraft.spruce_stairs": "Świyrkowe słody",
  "block.minecraft.spruce_trapdoor": "Świyrkowo szłapa",
  "block.minecraft.spruce_wall_hanging_sign": "Świyrkowy ściynny szild",
  "block.minecraft.spruce_wall_sign": "Świyrkowy ściynny znak",
  "block.minecraft.spruce_wood": "Świyrkowe drzewo",
  "block.minecraft.sticky_piston": "Lepki tłok",
  "block.minecraft.stone": "Kamiyń",
  "block.minecraft.stone_brick_slab": "Kamiynno ceglanno fliza",
  "block.minecraft.stone_brick_stairs": "Kamiynne ceglanne słody",
  "block.minecraft.stone_brick_wall": "Kamiynny ceglanny murek",
  "block.minecraft.stone_bricks": "Kamiynne cegły",
  "block.minecraft.stone_button": "Kamiynny knefel",
  "block.minecraft.stone_pressure_plate": "Kamiynno drukplata",
  "block.minecraft.stone_slab": "Kamiynno fliza",
  "block.minecraft.stone_stairs": "Kamiynne słody",
  "block.minecraft.stonecutter": "Krajzyga",
  "block.minecraft.stripped_acacia_log": "Ôkorowany sztam agacu",
  "block.minecraft.stripped_acacia_wood": "Ôkorowane agacowe drzewo",
  "block.minecraft.stripped_bamboo_block": "Blok ôkorowanego bambusa",
  "block.minecraft.stripped_birch_log": "Ôkorowany sztam brzizki",
  "block.minecraft.stripped_birch_wood": "Ôkorowane brzizkowe drzewo",
  "block.minecraft.stripped_cherry_log": "Ôkorowany sztam trześnie",
  "block.minecraft.stripped_cherry_wood": "Ôkorowane trześniowe drzewo",
  "block.minecraft.stripped_crimson_hyphae": "Ôkorowane szarłatne strzympki",
  "block.minecraft.stripped_crimson_stem": "Ôkorowany szarłatny sztil",
  "block.minecraft.stripped_dark_oak_log": "Ôkorowany sztam ćmawego dymbu",
  "block.minecraft.stripped_dark_oak_wood": "Ôkorowane ćmawodymbowe drzewo",
  "block.minecraft.stripped_jungle_log": "Ôkorowany sztam dżōnglowego strōmu",
  "block.minecraft.stripped_jungle_wood": "Ôkorowane dżōnglowe drzewo",
  "block.minecraft.stripped_mangrove_log": "Ôkorowany sztam namorzinu",
  "block.minecraft.stripped_mangrove_wood": "Ôkorowane namorzinowe drzewo",
  "block.minecraft.stripped_oak_log": "Ôkorowany sztam dymbu",
  "block.minecraft.stripped_oak_wood": "Ôkorowane dymbowe drzewo",
  "block.minecraft.stripped_pale_oak_log": "Ôkorowany sztam bladego dymbu",
  "block.minecraft.stripped_pale_oak_wood": "Ôkorowane bladodymbowe drzewo",
  "block.minecraft.stripped_spruce_log": "Ôkorowany sztam świyrku",
  "block.minecraft.stripped_spruce_wood": "Ôkorowane świyrkowe drzewo",
  "block.minecraft.stripped_warped_hyphae": "Ôkorowane szage strzympki",
  "block.minecraft.stripped_warped_stem": "Ôkorowano szagi sztil",
  "block.minecraft.structure_block": "Strukturowy blok",
  "block.minecraft.structure_void": "Strukturalno prōżnia",
  "block.minecraft.sugar_cane": "Cukrowo trzcina",
  "block.minecraft.sunflower": "Zōnynbluma",
  "block.minecraft.suspicious_gravel": "Podyjzdrzany kis",
  "block.minecraft.suspicious_sand": "Podyjzdrzany piosek",
  "block.minecraft.sweet_berry_bush": "Borōwczywie",
  "block.minecraft.tall_dry_grass": "Sucho wysoko trowa",
  "block.minecraft.tall_grass": "Wysoko trowa",
  "block.minecraft.tall_seagrass": "Wysoko morsko trowa",
  "block.minecraft.target": "Szisszajba",
  "block.minecraft.terracotta": "Kamiōnka",
  "block.minecraft.test_block": "Prifōngowy blok",
  "block.minecraft.test_instance_block": "Blok wystōmpiynio prifōngu",
  "block.minecraft.tinted_glass": "Ćmawe szkło",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Abszusy TNT sōm wyłōnczōne",
  "block.minecraft.torch": "Fakla",
  "block.minecraft.torchflower": "Fakliczka",
  "block.minecraft.torchflower_crop": "Fakliczka",
  "block.minecraft.trapped_chest": "Paść-kastla",
  "block.minecraft.trial_spawner": "Swoływocz prōb",
  "block.minecraft.tripwire": "Linka",
  "block.minecraft.tripwire_hook": "Hok na linka",
  "block.minecraft.tube_coral": "Rułkowy korol",
  "block.minecraft.tube_coral_block": "Blok rułkowego korolu",
  "block.minecraft.tube_coral_fan": "Rułkowo gorgonia",
  "block.minecraft.tube_coral_wall_fan": "Ściynno rułkowo gorgonia",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Tufowo ceglanno fliza",
  "block.minecraft.tuff_brick_stairs": "Tufowe ceglanne słody",
  "block.minecraft.tuff_brick_wall": "Tufowy ceglanny murek",
  "block.minecraft.tuff_bricks": "Tufowe cegły",
  "block.minecraft.tuff_slab": "Tufowo fliza",
  "block.minecraft.tuff_stairs": "Tufowe słody",
  "block.minecraft.tuff_wall": "Tufowy murek",
  "block.minecraft.turtle_egg": "Żōłwie jajco",
  "block.minecraft.twisting_vines": "Szage kleterflance",
  "block.minecraft.twisting_vines_plant": "Szage kleterflance",
  "block.minecraft.vault": "Szac",
  "block.minecraft.verdant_froglight": "Zielenno blyndołza",
  "block.minecraft.vine": "Kleterflance",
  "block.minecraft.void_air": "Prōżniowy luft",
  "block.minecraft.wall_torch": "Ściynno fakla",
  "block.minecraft.warped_button": "Szagi knefel",
  "block.minecraft.warped_door": "Szage dźwiyrze",
  "block.minecraft.warped_fence": "Szagi płot",
  "block.minecraft.warped_fence_gate": "Szago wrōtka",
  "block.minecraft.warped_fungus": "Szagi grzib",
  "block.minecraft.warped_hanging_sign": "Szagi szild",
  "block.minecraft.warped_hyphae": "Szage strzympki",
  "block.minecraft.warped_nylium": "Szagi mycel",
  "block.minecraft.warped_planks": "Szage brety",
  "block.minecraft.warped_pressure_plate": "Szago drukplata",
  "block.minecraft.warped_roots": "Szage wōrcle",
  "block.minecraft.warped_shelf": "Szago pōłka",
  "block.minecraft.warped_sign": "Szagi znak",
  "block.minecraft.warped_slab": "Szago fliza",
  "block.minecraft.warped_stairs": "Szage słody",
  "block.minecraft.warped_stem": "Szagi sztil",
  "block.minecraft.warped_trapdoor": "Szago szłapa",
  "block.minecraft.warped_wall_hanging_sign": "Szagi ściynny szild",
  "block.minecraft.warped_wall_sign": "Szagi ściynny znak",
  "block.minecraft.warped_wart_block": "Blok szagij kurzowki",
  "block.minecraft.water": "Woda",
  "block.minecraft.water_cauldron": "Kesel wody",
  "block.minecraft.waxed_chiseled_copper": "Waksowano wyrobiano miydź",
  "block.minecraft.waxed_copper_bars": "Waksowano miedzianno krota",
  "block.minecraft.waxed_copper_block": "Waksowany blok miedzi",
  "block.minecraft.waxed_copper_bulb": "Waksowano miedzianno byrna",
  "block.minecraft.waxed_copper_chain": "Waksowano miedzianno keta",
  "block.minecraft.waxed_copper_chest": "Waksowano miedzianno kastla",
  "block.minecraft.waxed_copper_door": "Waksowane miedzianne dźwiyrze",
  "block.minecraft.waxed_copper_golem_statue": "Waksowany posōng miedziannego golyma",
  "block.minecraft.waxed_copper_grate": "Waksowane miedzianne mrzeże",
  "block.minecraft.waxed_copper_lantern": "Waksowano miedzianno laterna",
  "block.minecraft.waxed_copper_trapdoor": "Waksowano miedzianno szłapa",
  "block.minecraft.waxed_cut_copper": "Waksowano żłobiōno miydź",
  "block.minecraft.waxed_cut_copper_slab": "Waksowano żłobiōno miedzianno fliza",
  "block.minecraft.waxed_cut_copper_stairs": "Waksowane żłobiōne miedzianne słody",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waksowano leko utlyniōno wyrobiano miydź",
  "block.minecraft.waxed_exposed_copper": "Waksowano leko utlyniōno miydź",
  "block.minecraft.waxed_exposed_copper_bars": "Waksowano leko utlyniōno miedzianno krota",
  "block.minecraft.waxed_exposed_copper_bulb": "Waksowano leko utlyniōno miedzianno byrna",
  "block.minecraft.waxed_exposed_copper_chain": "Waksowano leko utlyniōno miedzianno keta",
  "block.minecraft.waxed_exposed_copper_chest": "Waksowano leko utlyniōno miedzianno kastla",
  "block.minecraft.waxed_exposed_copper_door": "Waksowane leko utlyniōne miedzianne dźwiyrze",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waksowany leko utlyniōny posōng miedziannego golyma",
  "block.minecraft.waxed_exposed_copper_grate": "Waksowane leko utlyniōne miedzianne mrzeże",
  "block.minecraft.waxed_exposed_copper_lantern": "Waksowano leko utlyniōno miedzianno laterna",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waksowano leko utlyniōno miedzianno szłapa",
  "block.minecraft.waxed_exposed_cut_copper": "Waksowano leko utlyniōno żłobiōno miydź",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Waksowano leko utlyniōno żłobiōno miedzianno fliza",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Waksowane leko utlyniōne żłobiōne miedzianne słody",
  "block.minecraft.waxed_exposed_lightning_rod": "Waksowany leko utlyniōny blicablajter",
  "block.minecraft.waxed_lightning_rod": "Waksowany blicablajter",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waksowano utlyniōno wyrobiano miydź",
  "block.minecraft.waxed_oxidized_copper": "Waksowano utlyniōno miydź",
  "block.minecraft.waxed_oxidized_copper_bars": "Waksowano utlyniōno miedzianno krota",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waksowano utlyniōno miedzianno byrna",
  "block.minecraft.waxed_oxidized_copper_chain": "Waksowano utlyniōno miedzianno keta",
  "block.minecraft.waxed_oxidized_copper_chest": "Waksowano utlyniōno miedzianno kastla",
  "block.minecraft.waxed_oxidized_copper_door": "Waksowane utlyniōne miedzianne dźwiyrze",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waksowany utlyniōny posōng miedziannego golyma",
  "block.minecraft.waxed_oxidized_copper_grate": "Waksowane utlyniōne miedzianne mrzeże",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waksowano utlyniōno miedzianno laterna",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waksowano utlyniōno miedzianno szłapa",
  "block.minecraft.waxed_oxidized_cut_copper": "Waksowano utlyniōno żłobiōno miydź",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waksowano utlyniōno żłobiōno miedzianno fliza",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Waksowane utlyniōne żłobiōne miedzianne słody",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waksowany utlyniōny blicablajter",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waksowano strzednio utlyniōno wyrobiano miydź",
  "block.minecraft.waxed_weathered_copper": "Waksowano strzednio utlyniōno miydź",
  "block.minecraft.waxed_weathered_copper_bars": "Waksowano strzednio utlyniōno miedzianno krota",
  "block.minecraft.waxed_weathered_copper_bulb": "Waksowano strzednio utlyniōno miedzianno byrna",
  "block.minecraft.waxed_weathered_copper_chain": "Waksowano strzednio utlyniōno miedzianno keta",
  "block.minecraft.waxed_weathered_copper_chest": "Waksowano strzednio utlyniōno miedzianno kastla",
  "block.minecraft.waxed_weathered_copper_door": "Waksowane strzednio utlyniōne miedzianne dźwiyrze",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waksowany strzednio utlyniōny posōng miedziannego golyma",
  "block.minecraft.waxed_weathered_copper_grate": "Waksowane strzednio utlyniōne miedzianne mrzeże",
  "block.minecraft.waxed_weathered_copper_lantern": "Waksowano strzednio utlyniōno miedzianno laterna",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waksowano strzednio utlyniōno miedzianno szłapa",
  "block.minecraft.waxed_weathered_cut_copper": "Waksowano strzednio utlyniōno żłobiōno miydź",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waksowano strzednio utlyniōno żłobiōno miedzianno fliza",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Waksowane strzednio utlyniōne żłobiōne miedzianne słody",
  "block.minecraft.waxed_weathered_lightning_rod": "Waksowany strzednio utlyniōny blicablajter",
  "block.minecraft.weathered_chiseled_copper": "Strzednio utlyniōno wyrobiano miydź",
  "block.minecraft.weathered_copper": "Strzednio utlyniōno miydź",
  "block.minecraft.weathered_copper_bars": "Strzednio utlyniōno miedzianno krota",
  "block.minecraft.weathered_copper_bulb": "Strzednio utlyniōno miedzianno byrna",
  "block.minecraft.weathered_copper_chain": "Strzednio utlyniōno miedzianno keta",
  "block.minecraft.weathered_copper_chest": "Strzednio utlyniōno miedzianno kastla",
  "block.minecraft.weathered_copper_door": "Strzednio utlyniōne miedzianne dźwiyrze",
  "block.minecraft.weathered_copper_golem_statue": "Strzednio utlyniōny posōng miedziannego golyma",
  "block.minecraft.weathered_copper_grate": "Strzednio utlyniōne miedzianne mrzeże",
  "block.minecraft.weathered_copper_lantern": "Strzednio utlyniōno miedzianno laterna",
  "block.minecraft.weathered_copper_trapdoor": "Strzednio utlyniōno miedzianno szłapa",
  "block.minecraft.weathered_cut_copper": "Strzednio utlyniōno żłobiōno miydź",
  "block.minecraft.weathered_cut_copper_slab": "Strzednio utlyniōno żłobiōno miedzianno fliza",
  "block.minecraft.weathered_cut_copper_stairs": "Strzednio utlyniōne żłobiōne miedzianne słody",
  "block.minecraft.weathered_lightning_rod": "Strzednio utlyniōny blicablajter",
  "block.minecraft.weeping_vines": "Szarłatne kleterflance",
  "block.minecraft.weeping_vines_plant": "Szarłatne kleterflance",
  "block.minecraft.wet_sponge": "Mokro gōmbka",
  "block.minecraft.wheat": "Pszynica",
  "block.minecraft.white_banner": "Bioło fana",
  "block.minecraft.white_bed": "Biołe łōżko",
  "block.minecraft.white_candle": "Bioło świyczka",
  "block.minecraft.white_candle_cake": "Torta ze biołōm świyczkōm",
  "block.minecraft.white_carpet": "Bioły tepich",
  "block.minecraft.white_concrete": "Bioły betōn",
  "block.minecraft.white_concrete_powder": "Bioły cymynt",
  "block.minecraft.white_glazed_terracotta": "Bioło glaziyrowano kamiōnka",
  "block.minecraft.white_shulker_box": "Bioło shulkerowo kastla",
  "block.minecraft.white_stained_glass": "Biołe szkło",
  "block.minecraft.white_stained_glass_pane": "Bioło szklanno tofla",
  "block.minecraft.white_terracotta": "Bioło kamiōnka",
  "block.minecraft.white_tulip": "Bioło tulpa",
  "block.minecraft.white_wool": "Bioło wołna",
  "block.minecraft.wildflowers": "Dzike kwioty",
  "block.minecraft.wither_rose": "Witherrōłza",
  "block.minecraft.wither_skeleton_skull": "Szala witherowego szkeleta",
  "block.minecraft.wither_skeleton_wall_skull": "Ściynno szala witherowego szkeleta",
  "block.minecraft.yellow_banner": "Żōłto fana",
  "block.minecraft.yellow_bed": "Żōłte łōżko",
  "block.minecraft.yellow_candle": "Żōłto świyczka",
  "block.minecraft.yellow_candle_cake": "Torta ze żōłtōm świyczkōm",
  "block.minecraft.yellow_carpet": "Żōłty tepich",
  "block.minecraft.yellow_concrete": "Żōłty betōn",
  "block.minecraft.yellow_concrete_powder": "Żōłty cymynt",
  "block.minecraft.yellow_glazed_terracotta": "Żōłto glaziyrowano kamiōnka",
  "block.minecraft.yellow_shulker_box": "Żōłto shulkerowo kastla",
  "block.minecraft.yellow_stained_glass": "Żōłte szkło",
  "block.minecraft.yellow_stained_glass_pane": "Żōłto szklanno tofla",
  "block.minecraft.yellow_terracotta": "Żōłto kamiōnka",
  "block.minecraft.yellow_wool": "Żōłto wołna",
  "block.minecraft.zombie_head": "Gowa umarloka",
  "block.minecraft.zombie_wall_head": "Ściynno gowa umarloka",
  "item.minecraft.acacia_boat": "Agacowo łōdka",
  "item.minecraft.acacia_chest_boat": "Agacowo łōdka ze kastlōm",
  "item.minecraft.allay_spawn_egg": "Jajco ze przociuchym",
  "item.minecraft.amethyst_shard": "Szpliter ametystu",
  "item.minecraft.angler_pottery_shard": "Szpliter ze wyndkōm",
  "item.minecraft.angler_pottery_sherd": "Szpliter ze wyndkōm",
  "item.minecraft.apple": "Pōnka",
  "item.minecraft.archer_pottery_shard": "Szpliter ze łukym",
  "item.minecraft.archer_pottery_sherd": "Szpliter ze łukym",
  "item.minecraft.armadillo_scute": "Ôbryncznikowo szupa",
  "item.minecraft.armadillo_spawn_egg": "Jajco ze ôbryncznikym",
  "item.minecraft.armor_stand": "Sztynder na pancer",
  "item.minecraft.arms_up_pottery_shard": "Szpliter ze zniysiōnymi rynkami",
  "item.minecraft.arms_up_pottery_sherd": "Szpliter ze zniysiōnymi rynkami",
  "item.minecraft.arrow": "Strzała",
  "item.minecraft.axolotl_bucket": "Kibel ze aksolotlym",
  "item.minecraft.axolotl_spawn_egg": "Jajco ze aksolotlym",
  "item.minecraft.baked_potato": "Piyczok",
  "item.minecraft.bamboo_chest_raft": "Bambusowo mataczka ze kastlōm",
  "item.minecraft.bamboo_raft": "Bambusowo mataczka",
  "item.minecraft.bat_spawn_egg": "Jajco ze flyjdermausym",
  "item.minecraft.bee_spawn_egg": "Jajco ze binōm",
  "item.minecraft.beef": "Surowo ôwiynzina",
  "item.minecraft.beetroot": "Ćwikla",
  "item.minecraft.beetroot_seeds": "Ziorna ćwikle",
  "item.minecraft.beetroot_soup": "Borszcz",
  "item.minecraft.birch_boat": "Brzizkowo łōdka",
  "item.minecraft.birch_chest_boat": "Brzizkowo łōdka ze kastlōm",
  "item.minecraft.black_bundle": "Czorny miyszek",
  "item.minecraft.black_dye": "Czorny farbsztof",
  "item.minecraft.black_harness": "Czorny gyszir",
  "item.minecraft.blade_pottery_shard": "Szpliter ze sznajdōm",
  "item.minecraft.blade_pottery_sherd": "Szpliter ze sznajdōm",
  "item.minecraft.blaze_powder": "Flamokowy pulwer",
  "item.minecraft.blaze_rod": "Flamokowo ruta",
  "item.minecraft.blaze_spawn_egg": "Jajco ze flamokym",
  "item.minecraft.blue_bundle": "Modry miyszek",
  "item.minecraft.blue_dye": "Modry farbsztof",
  "item.minecraft.blue_egg": "Modre jajco",
  "item.minecraft.blue_harness": "Modry gyszir",
  "item.minecraft.bogged_spawn_egg": "Jajco ze bagyniokym",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ôrnamynt — Szrauba",
  "item.minecraft.bone": "Kostyra",
  "item.minecraft.bone_meal": "Knochynmyjl",
  "item.minecraft.book": "Ksiōnżka",
  "item.minecraft.bordure_indented_banner_pattern": "Muster fany — Faltowano rōma",
  "item.minecraft.bow": "Łuk",
  "item.minecraft.bowl": "Sziselka",
  "item.minecraft.bread": "Chlyb",
  "item.minecraft.breeze_rod": "Wiytrzikowo ruta",
  "item.minecraft.breeze_spawn_egg": "Jajco ze wiytrzikym",
  "item.minecraft.brewer_pottery_shard": "Szpliter ze wywarym",
  "item.minecraft.brewer_pottery_sherd": "Szpliter ze wywarym",
  "item.minecraft.brewing_stand": "Sztynder ku warzyniu",
  "item.minecraft.brick": "Cegła",
  "item.minecraft.brown_bundle": "Brōnotny miyszek",
  "item.minecraft.brown_dye": "Brōnotny farbsztof",
  "item.minecraft.brown_egg": "Brōnotne jajco",
  "item.minecraft.brown_harness": "Brōnotny gyszir",
  "item.minecraft.brush": "Pyndzel",
  "item.minecraft.bucket": "Kibel",
  "item.minecraft.bundle": "Miyszek",
  "item.minecraft.bundle.empty": "Prōżny",
  "item.minecraft.bundle.empty.description": "Śmi chować sztapel roztōmańtych rzeczy",
  "item.minecraft.bundle.full": "Połny",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Szpliter ze ôgniym",
  "item.minecraft.burn_pottery_sherd": "Szpliter ze ôgniym",
  "item.minecraft.camel_husk_spawn_egg": "Jajco ze kamelōm-suchlokym",
  "item.minecraft.camel_spawn_egg": "Jajco ze kamelōm",
  "item.minecraft.carrot": "Markew",
  "item.minecraft.carrot_on_a_stick": "Markew na kijoku",
  "item.minecraft.cat_spawn_egg": "Jajco ze kotym",
  "item.minecraft.cauldron": "Kesel",
  "item.minecraft.cave_spider_spawn_egg": "Jajco ze jaskiniowym pajōnkym",
  "item.minecraft.chainmail_boots": "Ketowe strzewiki",
  "item.minecraft.chainmail_chestplate": "Ketowy kyras",
  "item.minecraft.chainmail_helmet": "Ketowy helm",
  "item.minecraft.chainmail_leggings": "Ketowe galoty",
  "item.minecraft.charcoal": "Drzewnianny wōngel",
  "item.minecraft.cherry_boat": "Trześniowo łōdka",
  "item.minecraft.cherry_chest_boat": "Trześniowo łōdka ze kastlōm",
  "item.minecraft.chest_minecart": "Wagōn ze kastlōm",
  "item.minecraft.chicken": "Surowo kura",
  "item.minecraft.chicken_spawn_egg": "Jajco ze kurōm",
  "item.minecraft.chorus_fruit": "Ôwoc refrynice",
  "item.minecraft.clay_ball": "Kugel gliny",
  "item.minecraft.clock": "Zygor",
  "item.minecraft.coal": "Wōngel",
  "item.minecraft.coast_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ôrnamynt — Wybrzeże",
  "item.minecraft.cocoa_beans": "Ziorna kakau",
  "item.minecraft.cod": "Surowy dorsz",
  "item.minecraft.cod_bucket": "Kibel ze dorszym",
  "item.minecraft.cod_spawn_egg": "Jajco ze dorszym",
  "item.minecraft.command_block_minecart": "Wagōn ze blokym przikazōw",
  "item.minecraft.compass": "Kōmpas",
  "item.minecraft.cooked_beef": "Pieczōno ôwiynzina",
  "item.minecraft.cooked_chicken": "Pieczōno kura",
  "item.minecraft.cooked_cod": "Pieczōny dorsz",
  "item.minecraft.cooked_mutton": "Pieczōno szkopina",
  "item.minecraft.cooked_porkchop": "Pieczōno wieprzowina",
  "item.minecraft.cooked_rabbit": "Piyczōny mycok",
  "item.minecraft.cooked_salmon": "Pieczōny laks",
  "item.minecraft.cookie": "Kyjks",
  "item.minecraft.copper_axe": "Miedzianno siekiyra",
  "item.minecraft.copper_boots": "Miedzianne strzewiki",
  "item.minecraft.copper_chestplate": "Miedzianny kyras",
  "item.minecraft.copper_golem_spawn_egg": "Jajco ze miedziannym golymym",
  "item.minecraft.copper_helmet": "Miedzianny helm",
  "item.minecraft.copper_hoe": "Miedzianny kopocz",
  "item.minecraft.copper_horse_armor": "Miedzianny kōński pancer",
  "item.minecraft.copper_ingot": "Sztangelka miedzi",
  "item.minecraft.copper_leggings": "Miedzianne galoty",
  "item.minecraft.copper_nautilus_armor": "Miedzianny łodzikowy pancer",
  "item.minecraft.copper_nugget": "Łupa miedzi",
  "item.minecraft.copper_pickaxe": "Miedzianno haka",
  "item.minecraft.copper_shovel": "Miedzianny ryl",
  "item.minecraft.copper_spear": "Miedzianno szpisa",
  "item.minecraft.copper_sword": "Miedzianny miycz",
  "item.minecraft.cow_spawn_egg": "Jajco ze krowōm",
  "item.minecraft.creaking_spawn_egg": "Jajco ze grzipoczym",
  "item.minecraft.creeper_banner_pattern": "Muster fany",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Muster fany — Creeper",
  "item.minecraft.creeper_spawn_egg": "Jajco ze creeperym",
  "item.minecraft.crossbow": "Kusza",
  "item.minecraft.crossbow.projectile": "Szus:",
  "item.minecraft.crossbow.projectile.multiple": "Szus: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Szus: %s",
  "item.minecraft.cyan_bundle": "Cyjanowy miyszek",
  "item.minecraft.cyan_dye": "Cyjanowy farbsztof",
  "item.minecraft.cyan_harness": "Cyjanowy gyszir",
  "item.minecraft.danger_pottery_shard": "Szpliter ze creeperym",
  "item.minecraft.danger_pottery_sherd": "Szpliter ze creeperym",
  "item.minecraft.dark_oak_boat": "Ćmawodymbowo łōdka",
  "item.minecraft.dark_oak_chest_boat": "Ćmawodymbowo łōdka ze kastlōm",
  "item.minecraft.debug_stick": "Kijok ku debugowaniu",
  "item.minecraft.debug_stick.empty": "%s niy mo włosności",
  "item.minecraft.debug_stick.select": "ôbrano „%s” (%s)",
  "item.minecraft.debug_stick.update": "nasztalōwano „%s” na: %s",
  "item.minecraft.diamond": "Dyjamynt",
  "item.minecraft.diamond_axe": "Dyjamyntowo siekiyra",
  "item.minecraft.diamond_boots": "Dyjamyntowe strzewiki",
  "item.minecraft.diamond_chestplate": "Dyjamyntowy kyras",
  "item.minecraft.diamond_helmet": "Dyjamyntowy helm",
  "item.minecraft.diamond_hoe": "Dyjamyntowy kopocz",
  "item.minecraft.diamond_horse_armor": "Dyjamyntowy kōński pancer",
  "item.minecraft.diamond_leggings": "Dyjamyntowe galoty",
  "item.minecraft.diamond_nautilus_armor": "Dyjamyntowy łodzikowy pancer",
  "item.minecraft.diamond_pickaxe": "Dyjamyntowo haka",
  "item.minecraft.diamond_shovel": "Dyjamyntowy ryl",
  "item.minecraft.diamond_spear": "Dyjamyntowo szpisa",
  "item.minecraft.diamond_sword": "Dyjamyntowy miycz",
  "item.minecraft.disc_fragment_5": "Skrowek dysketki",
  "item.minecraft.disc_fragment_5.desc": "Dysketka — 5",
  "item.minecraft.dolphin_spawn_egg": "Jajco ze delfinym",
  "item.minecraft.donkey_spawn_egg": "Jajco ze yjzlym",
  "item.minecraft.dragon_breath": "Drachowy dych",
  "item.minecraft.dried_kelp": "Wysuszōno waserflanca",
  "item.minecraft.drowned_spawn_egg": "Jajco ze utopkym",
  "item.minecraft.dune_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ôrnamynt — Wydma",
  "item.minecraft.echo_shard": "Szpliter pogłosu",
  "item.minecraft.egg": "Jajco",
  "item.minecraft.elder_guardian_spawn_egg": "Jajco ze chańdownym wachtyrzym",
  "item.minecraft.elytra": "Ôkrywy",
  "item.minecraft.emerald": "Szmaragd",
  "item.minecraft.enchanted_book": "Zaklynto ksiōnżka",
  "item.minecraft.enchanted_golden_apple": "Zaklynto złōto pōnka",
  "item.minecraft.end_crystal": "Krysztoł Endu",
  "item.minecraft.ender_dragon_spawn_egg": "Jajco ze drachym Endu",
  "item.minecraft.ender_eye": "Ślypie Endu",
  "item.minecraft.ender_pearl": "Perla Endu",
  "item.minecraft.enderman_spawn_egg": "Jajco ze endermanym",
  "item.minecraft.endermite_spawn_egg": "Jajco ze endermitym",
  "item.minecraft.evoker_spawn_egg": "Jajco ze guślorzym",
  "item.minecraft.experience_bottle": "Flaszka doświodczynio",
  "item.minecraft.explorer_pottery_shard": "Szpliter ze kartōm",
  "item.minecraft.explorer_pottery_sherd": "Szpliter ze kartōm",
  "item.minecraft.eye_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ôrnamynt — Ślypie",
  "item.minecraft.feather": "Fyjder",
  "item.minecraft.fermented_spider_eye": "Zgerowane ślypie pajōnka",
  "item.minecraft.field_masoned_banner_pattern": "Muster fany — Mur",
  "item.minecraft.filled_map": "Karta",
  "item.minecraft.fire_charge": "Ôgnisto kula",
  "item.minecraft.firework_rocket": "Fojerwerk",
  "item.minecraft.firework_rocket.flight": "Czas lotu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fojerwerkowo gwiozda",
  "item.minecraft.firework_star.black": "Czorno",
  "item.minecraft.firework_star.blue": "Modro",
  "item.minecraft.firework_star.brown": "Brōnotno",
  "item.minecraft.firework_star.custom_color": "Niysztandardowo",
  "item.minecraft.firework_star.cyan": "Cyjanowo",
  "item.minecraft.firework_star.fade_to": "Przechodzynie w",
  "item.minecraft.firework_star.flicker": "Iskrzynie",
  "item.minecraft.firework_star.gray": "Siwo",
  "item.minecraft.firework_star.green": "Zielōno",
  "item.minecraft.firework_star.light_blue": "Światłomodro",
  "item.minecraft.firework_star.light_gray": "Światłosiwo",
  "item.minecraft.firework_star.lime": "Limōnkowo",
  "item.minecraft.firework_star.magenta": "Purpurowo",
  "item.minecraft.firework_star.orange": "Ôranżowo",
  "item.minecraft.firework_star.pink": "Rōżowo",
  "item.minecraft.firework_star.purple": "Flidrowo",
  "item.minecraft.firework_star.red": "Czyrwōno",
  "item.minecraft.firework_star.shape": "Niyznany ksztołt",
  "item.minecraft.firework_star.shape.burst": "Rozproszynie",
  "item.minecraft.firework_star.shape.creeper": "Ksztołt: Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Ksztołt: Wielgo kula",
  "item.minecraft.firework_star.shape.small_ball": "Ksztołt: Mało kula",
  "item.minecraft.firework_star.shape.star": "Ksztołt: Gwiozda",
  "item.minecraft.firework_star.trail": "Sztreka",
  "item.minecraft.firework_star.white": "Bioło",
  "item.minecraft.firework_star.yellow": "Żōłto",
  "item.minecraft.fishing_rod": "Wyndka",
  "item.minecraft.flint": "Flint",
  "item.minecraft.flint_and_steel": "Krzosadło",
  "item.minecraft.flow_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ôrnamynt — Przepływ",
  "item.minecraft.flow_banner_pattern": "Muster fany",
  "item.minecraft.flow_banner_pattern.desc": "Wir",
  "item.minecraft.flow_banner_pattern.new": "Muster fany — Wir",
  "item.minecraft.flow_pottery_sherd": "Szpliter ze wirym",
  "item.minecraft.flower_banner_pattern": "Muster fany",
  "item.minecraft.flower_banner_pattern.desc": "Kwiotek",
  "item.minecraft.flower_banner_pattern.new": "Muster fany — Kwiotek",
  "item.minecraft.flower_pot": "Ôtka",
  "item.minecraft.fox_spawn_egg": "Jajco z liszkōm",
  "item.minecraft.friend_pottery_shard": "Szkyrtek ze przociuchym",
  "item.minecraft.friend_pottery_sherd": "Szpliter ze przociuchym",
  "item.minecraft.frog_spawn_egg": "Jajco ze rapitołzōm",
  "item.minecraft.furnace_minecart": "Wagōn ze żeleźniokym",
  "item.minecraft.ghast_spawn_egg": "Jajco ze ghastym",
  "item.minecraft.ghast_tear": "Ghastowo płaczka",
  "item.minecraft.glass_bottle": "Flaszka",
  "item.minecraft.glistering_melon_slice": "Złōtawy kōnsek wasermelōna",
  "item.minecraft.globe_banner_pattern": "Muster fany",
  "item.minecraft.globe_banner_pattern.desc": "Ziymiokostka",
  "item.minecraft.globe_banner_pattern.new": "Muster fany — Ziymia",
  "item.minecraft.glow_berries": "Świycōnce jagody",
  "item.minecraft.glow_ink_sac": "Bojtlik ze blyndtintōm",
  "item.minecraft.glow_item_frame": "Blyndrōma",
  "item.minecraft.glow_squid_spawn_egg": "Jajco ze świycōncōm tintynfiszōm",
  "item.minecraft.glowstone_dust": "Blyndokowy pulwer",
  "item.minecraft.goat_horn": "Cigowy rōg",
  "item.minecraft.goat_spawn_egg": "Jajco ze cigōm",
  "item.minecraft.gold_ingot": "Sztangelka złōta",
  "item.minecraft.gold_nugget": "Łupa złōta",
  "item.minecraft.golden_apple": "Złōto pōnka",
  "item.minecraft.golden_axe": "Złōto siekiyra",
  "item.minecraft.golden_boots": "Złōte strzewiki",
  "item.minecraft.golden_carrot": "Złōto markew",
  "item.minecraft.golden_chestplate": "Złōty kyras",
  "item.minecraft.golden_helmet": "Złōty helm",
  "item.minecraft.golden_hoe": "Złōty kopocz",
  "item.minecraft.golden_horse_armor": "Złōty kōński pancer",
  "item.minecraft.golden_leggings": "Złōte galoty",
  "item.minecraft.golden_nautilus_armor": "Złoty łodzikowy pancer",
  "item.minecraft.golden_pickaxe": "Złōto haka",
  "item.minecraft.golden_shovel": "Złōty ryl",
  "item.minecraft.golden_spear": "Złoto szpisa",
  "item.minecraft.golden_sword": "Złōty miycz",
  "item.minecraft.gray_bundle": "Siwy miyszek",
  "item.minecraft.gray_dye": "Siwy farbsztof",
  "item.minecraft.gray_harness": "Siwy gyszir",
  "item.minecraft.green_bundle": "Zielōny miyszek",
  "item.minecraft.green_dye": "Zielōny farbsztof",
  "item.minecraft.green_harness": "Zielōny gyszir",
  "item.minecraft.guardian_spawn_egg": "Jajco ze wachtyrzym",
  "item.minecraft.gunpowder": "Proch",
  "item.minecraft.guster_banner_pattern": "Muster fany",
  "item.minecraft.guster_banner_pattern.desc": "Wiytrzik",
  "item.minecraft.guster_banner_pattern.new": "Muster fany — Wiytrzik",
  "item.minecraft.guster_pottery_sherd": "Szpliter ze wiytrzykym",
  "item.minecraft.happy_ghast_spawn_egg": "Jajco ze uciesznym ghastym",
  "item.minecraft.harness": "Gyszir",
  "item.minecraft.heart_of_the_sea": "Syrce ôceanu",
  "item.minecraft.heart_pottery_shard": "Szpliter ze syrcym",
  "item.minecraft.heart_pottery_sherd": "Szpliter ze syrcym",
  "item.minecraft.heartbreak_pottery_shard": "Szpliter ze złōmanym syrcym",
  "item.minecraft.heartbreak_pottery_sherd": "Szpliter ze złōmanym syrcym",
  "item.minecraft.hoglin_spawn_egg": "Jajco ze hoglinym",
  "item.minecraft.honey_bottle": "Flaszka miodu",
  "item.minecraft.honeycomb": "Ślyzyk miodu",
  "item.minecraft.hopper_minecart": "Wagōn ze lyjokym",
  "item.minecraft.horse_spawn_egg": "Jajco ze kōniym",
  "item.minecraft.host_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ôrnamynt — Gospodorz",
  "item.minecraft.howl_pottery_shard": "Szpliter ze wilkym",
  "item.minecraft.howl_pottery_sherd": "Szpliter ze wilkym",
  "item.minecraft.husk_spawn_egg": "Jajco ze suchlokym",
  "item.minecraft.ink_sac": "Bojtlik ze tintōm",
  "item.minecraft.iron_axe": "Żelazno siekiyra",
  "item.minecraft.iron_boots": "Żelazne strzewiki",
  "item.minecraft.iron_chestplate": "Żelazny kyras",
  "item.minecraft.iron_golem_spawn_egg": "Jajco ze żelaznym golymym",
  "item.minecraft.iron_helmet": "Żelazny helm",
  "item.minecraft.iron_hoe": "Żelazny kopocz",
  "item.minecraft.iron_horse_armor": "Żelazny kōński pancer",
  "item.minecraft.iron_ingot": "Sztangelka żelazła",
  "item.minecraft.iron_leggings": "Żelazne galoty",
  "item.minecraft.iron_nautilus_armor": "Żelazny łodzikowy pancer",
  "item.minecraft.iron_nugget": "Łupa żelazła",
  "item.minecraft.iron_pickaxe": "Żelazno haka",
  "item.minecraft.iron_shovel": "Żelazny ryl",
  "item.minecraft.iron_spear": "Żelazno szpisa",
  "item.minecraft.iron_sword": "Żelazny miycz",
  "item.minecraft.item_frame": "Rōma",
  "item.minecraft.jungle_boat": "Dżōnglowo łōdka",
  "item.minecraft.jungle_chest_boat": "Dżōnglowo łōdka ze kastlōm",
  "item.minecraft.knowledge_book": "Encyklopedyjo",
  "item.minecraft.lapis_lazuli": "Lazuryt",
  "item.minecraft.lava_bucket": "Kibel lawy",
  "item.minecraft.lead": "Lajna",
  "item.minecraft.leather": "Skōra",
  "item.minecraft.leather_boots": "Skōrzanne strzewiki",
  "item.minecraft.leather_chestplate": "Skōrzanno jakla",
  "item.minecraft.leather_helmet": "Skōrzanno mycka",
  "item.minecraft.leather_horse_armor": "Skōrzanny kōński pancer",
  "item.minecraft.leather_leggings": "Skōrzanne galoty",
  "item.minecraft.light_blue_bundle": "Światłomodry miyszek",
  "item.minecraft.light_blue_dye": "Światłomodry farbsztof",
  "item.minecraft.light_blue_harness": "Światłomodry gyszir",
  "item.minecraft.light_gray_bundle": "Światłosiwy miyszek",
  "item.minecraft.light_gray_dye": "Światłosiwy farbsztof",
  "item.minecraft.light_gray_harness": "Światłosiwy gyszir",
  "item.minecraft.lime_bundle": "Limōnkowy miyszek",
  "item.minecraft.lime_dye": "Limōnkowy farbsztof",
  "item.minecraft.lime_harness": "Limōnkowy gyszir",
  "item.minecraft.lingering_potion": "Ôbłoczny wywar",
  "item.minecraft.lingering_potion.effect.awkward": "Ciyrpki ôbłoczny wywar",
  "item.minecraft.lingering_potion.effect.empty": "Niystwarzalny ôbłoczny wywar",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Ôbłoczny wywar ôbstocio ôgnia",
  "item.minecraft.lingering_potion.effect.harming": "Ôbłoczny wywar krziwdy",
  "item.minecraft.lingering_potion.effect.healing": "Ôbłoczny wywar lyczynio",
  "item.minecraft.lingering_potion.effect.infested": "Ôbłoczny wywar chrobajstwa",
  "item.minecraft.lingering_potion.effect.invisibility": "Ôbłoczny wywar niywidzialności",
  "item.minecraft.lingering_potion.effect.leaping": "Ôbłoczny wywar wysokego skokanio",
  "item.minecraft.lingering_potion.effect.levitation": "Ôbłoczny wywar lewitacyje",
  "item.minecraft.lingering_potion.effect.luck": "Ôbłoczny wywar szczyńścio",
  "item.minecraft.lingering_potion.effect.mundane": "Mgły ôbłoczny wywar",
  "item.minecraft.lingering_potion.effect.night_vision": "Ôbłoczny wywar widoczności we cimie",
  "item.minecraft.lingering_potion.effect.oozing": "Ôbłoczny wywar wyciykanio",
  "item.minecraft.lingering_potion.effect.poison": "Ôbłoczny wywar zagidzynio",
  "item.minecraft.lingering_potion.effect.regeneration": "Ôbłoczny wywar regyneracyje",
  "item.minecraft.lingering_potion.effect.slow_falling": "Ôbłoczny wywar powolnego spadowanio",
  "item.minecraft.lingering_potion.effect.slowness": "Ôbłoczny wywar uniyskorzynio",
  "item.minecraft.lingering_potion.effect.strength": "Ôbłoczny wywar siyły",
  "item.minecraft.lingering_potion.effect.swiftness": "Ôbłoczny wywar gibkości",
  "item.minecraft.lingering_potion.effect.thick": "Gynsty ôbłoczny wywar",
  "item.minecraft.lingering_potion.effect.turtle_master": "Ôbłoczny wywar żōłwiego majstra",
  "item.minecraft.lingering_potion.effect.water": "Ôbłoczno flaszka wody",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ôbłoczny wywar dychanio pod wodōm",
  "item.minecraft.lingering_potion.effect.weakness": "Ôbłoczny wywar lichoty",
  "item.minecraft.lingering_potion.effect.weaving": "Ôbłoczny wywar webera",
  "item.minecraft.lingering_potion.effect.wind_charged": "Ôbłoczny wywar naluftowanio",
  "item.minecraft.llama_spawn_egg": "Jajco ze lamōm",
  "item.minecraft.lodestone_compass": "Magnetytowy kōmpas",
  "item.minecraft.mace": "Buzdygōn",
  "item.minecraft.magenta_bundle": "Purpurowy miyszek",
  "item.minecraft.magenta_dye": "Purpurowy farbsztof",
  "item.minecraft.magenta_harness": "Purpurowy gyszir",
  "item.minecraft.magma_cream": "Magmowy krym",
  "item.minecraft.magma_cube_spawn_egg": "Jajco ze magmokym",
  "item.minecraft.mangrove_boat": "Namorzinowo łōdka",
  "item.minecraft.mangrove_chest_boat": "Namorzinowo łōdka ze kastlōm",
  "item.minecraft.map": "Prōżno karta",
  "item.minecraft.melon_seeds": "Ziorna wasermelōna",
  "item.minecraft.melon_slice": "Kōnsek wasermelōna",
  "item.minecraft.milk_bucket": "Kibel mlyka",
  "item.minecraft.minecart": "Wagōn",
  "item.minecraft.miner_pottery_shard": "Szpliter ze hakōm",
  "item.minecraft.miner_pottery_sherd": "Szpliter ze hakōm",
  "item.minecraft.mojang_banner_pattern": "Muster fany",
  "item.minecraft.mojang_banner_pattern.desc": "Coś",
  "item.minecraft.mojang_banner_pattern.new": "Muster fany — Coś",
  "item.minecraft.mooshroom_spawn_egg": "Jajco ze mooshroomym",
  "item.minecraft.mourner_pottery_shard": "Szpliter ze wachmajstrym",
  "item.minecraft.mourner_pottery_sherd": "Szpliter ze wachmajstrym",
  "item.minecraft.mule_spawn_egg": "Jajco ze maultiyrym",
  "item.minecraft.mushroom_stew": "Grzibiōnka",
  "item.minecraft.music_disc_11": "Dysketka",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Dysketka",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Dysketka",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Dysketka",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Dysketka",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Dysketka",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Dysketka",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Dysketka",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (Lajerka)",
  "item.minecraft.music_disc_far": "Dysketka",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Dysketka",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Dysketka",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Dysketka",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Dysketka",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Dysketka",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Dysketka",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Dysketka",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Dysketka",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Dysketka",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Muzyczno dysketka",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Dysketka",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Dysketka",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Surowo szkopina",
  "item.minecraft.name_tag": "Znacznik",
  "item.minecraft.nautilus_shell": "Łodzikowo muszla",
  "item.minecraft.nautilus_spawn_egg": "Jajco ze łodzikym",
  "item.minecraft.nether_brick": "Netherowo cegła",
  "item.minecraft.nether_star": "Netherowo gwiozda",
  "item.minecraft.nether_wart": "Netherowo kurzowka",
  "item.minecraft.netherite_axe": "Netherytowo siekiyra",
  "item.minecraft.netherite_boots": "Netherytowe strzewiki",
  "item.minecraft.netherite_chestplate": "Netherytowy kyras",
  "item.minecraft.netherite_helmet": "Netherytowy helm",
  "item.minecraft.netherite_hoe": "Netherytowy kopocz",
  "item.minecraft.netherite_horse_armor": "Netherytowy kōński pancer",
  "item.minecraft.netherite_ingot": "Sztangelka netherytu",
  "item.minecraft.netherite_leggings": "Netherytowe galoty",
  "item.minecraft.netherite_nautilus_armor": "Netherytowy łodzikowy pancer",
  "item.minecraft.netherite_pickaxe": "Netherytowo haka",
  "item.minecraft.netherite_scrap": "Netherytowy szrōt",
  "item.minecraft.netherite_shovel": "Netherytowy ryl",
  "item.minecraft.netherite_spear": "Netherytowo szpisa",
  "item.minecraft.netherite_sword": "Netherytowy miycz",
  "item.minecraft.netherite_upgrade_smithing_template": "Kowolski szablōn",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherytowe ulepszynie",
  "item.minecraft.oak_boat": "Dymbowo łōdka",
  "item.minecraft.oak_chest_boat": "Dymbowo łōdka ze kastlōm",
  "item.minecraft.ocelot_spawn_egg": "Jajco ze ôcelotym",
  "item.minecraft.ominous_bottle": "Lagramyncko flaszka",
  "item.minecraft.ominous_trial_key": "Lagramyncki klucz prōby",
  "item.minecraft.orange_bundle": "Ôranżowy miyszek",
  "item.minecraft.orange_dye": "Ôranżowy farbsztof",
  "item.minecraft.orange_harness": "Ôranżowy gyszir",
  "item.minecraft.painting": "Ôbroz",
  "item.minecraft.pale_oak_boat": "Bladodymbowo łōdka",
  "item.minecraft.pale_oak_chest_boat": "Bladodymbowo łōdka ze kastlōm",
  "item.minecraft.panda_spawn_egg": "Jajco ze pandōm",
  "item.minecraft.paper": "Papiōr",
  "item.minecraft.parched_spawn_egg": "Jajco ze oschlokym",
  "item.minecraft.parrot_spawn_egg": "Jajco ze papagajym",
  "item.minecraft.phantom_membrane": "Błōna mory",
  "item.minecraft.phantom_spawn_egg": "Jajco ze morōm",
  "item.minecraft.pig_spawn_egg": "Jajco ze świniōm",
  "item.minecraft.piglin_banner_pattern": "Muster fany",
  "item.minecraft.piglin_banner_pattern.desc": "Niurok",
  "item.minecraft.piglin_banner_pattern.new": "Muster fany — Niurok",
  "item.minecraft.piglin_brute_spawn_egg": "Jajco ze piglinym-doskwiyrnikym",
  "item.minecraft.piglin_spawn_egg": "Jajco ze piglinym",
  "item.minecraft.pillager_spawn_egg": "Jajco ze raubiyrzym",
  "item.minecraft.pink_bundle": "Rōżowy miyszek",
  "item.minecraft.pink_dye": "Rōżowy farbsztof",
  "item.minecraft.pink_harness": "Rōżowy gyszir",
  "item.minecraft.pitcher_plant": "Zbōnecznik",
  "item.minecraft.pitcher_pod": "Szota zbōnecznika",
  "item.minecraft.plenty_pottery_shard": "Szpliter ze kastlōm",
  "item.minecraft.plenty_pottery_sherd": "Szpliter ze kastlōm",
  "item.minecraft.poisonous_potato": "Jadliwy kartofel",
  "item.minecraft.polar_bear_spawn_egg": "Jajco ze polarnym miydźwiydziym",
  "item.minecraft.popped_chorus_fruit": "Piyczka refrynice",
  "item.minecraft.porkchop": "Surowo wieprzowina",
  "item.minecraft.potato": "Kartofel",
  "item.minecraft.potion": "Wywar",
  "item.minecraft.potion.effect.awkward": "Ciyrpki wywar",
  "item.minecraft.potion.effect.empty": "Niystwarzalny wywar",
  "item.minecraft.potion.effect.fire_resistance": "Wywar ôbstocio ôgnia",
  "item.minecraft.potion.effect.harming": "Wywar krziwdy",
  "item.minecraft.potion.effect.healing": "Wywar lyczynio",
  "item.minecraft.potion.effect.infested": "Wywar chrobajstwa",
  "item.minecraft.potion.effect.invisibility": "Wywar niywidzialności",
  "item.minecraft.potion.effect.leaping": "Wywar wysokego skokanio",
  "item.minecraft.potion.effect.levitation": "Wywar lewitacyje",
  "item.minecraft.potion.effect.luck": "Wywar szczyńścio",
  "item.minecraft.potion.effect.mundane": "Mdły wywar",
  "item.minecraft.potion.effect.night_vision": "Wywar widoczności we cimie",
  "item.minecraft.potion.effect.oozing": "Wywar wyciykanio",
  "item.minecraft.potion.effect.poison": "Wywar zagidzynio",
  "item.minecraft.potion.effect.regeneration": "Wywar regyneracyje",
  "item.minecraft.potion.effect.slow_falling": "Wywar powolnego spadowanio",
  "item.minecraft.potion.effect.slowness": "Wywar uniyskorzynio",
  "item.minecraft.potion.effect.strength": "Wywar siyły",
  "item.minecraft.potion.effect.swiftness": "Wywar gibkości",
  "item.minecraft.potion.effect.thick": "Gynsty wywar",
  "item.minecraft.potion.effect.turtle_master": "Wywar żōłwiego majstra",
  "item.minecraft.potion.effect.water": "Flaszka wody",
  "item.minecraft.potion.effect.water_breathing": "Wywar dychanio pod wodōm",
  "item.minecraft.potion.effect.weakness": "Wywar lichoty",
  "item.minecraft.potion.effect.weaving": "Wywar webera",
  "item.minecraft.potion.effect.wind_charged": "Wywar naluftowanio",
  "item.minecraft.pottery_shard_archer": "Szpliter ze łukym",
  "item.minecraft.pottery_shard_arms_up": "Szpliter ze zniysiōnymi rynkami",
  "item.minecraft.pottery_shard_prize": "Szpliter ze nadgrōdōm",
  "item.minecraft.pottery_shard_skull": "Szpliter ze szalōm",
  "item.minecraft.powder_snow_bucket": "Kibel sypkego śniega",
  "item.minecraft.prismarine_crystals": "Krysztoł prizmarynu",
  "item.minecraft.prismarine_shard": "Szpliter prizmarynu",
  "item.minecraft.prize_pottery_shard": "Szpliter ze nadgrōdōm",
  "item.minecraft.prize_pottery_sherd": "Szpliter ze nadgrōdōm",
  "item.minecraft.pufferfish": "Kugelfisza",
  "item.minecraft.pufferfish_bucket": "Kibel ze kugelfiszōm",
  "item.minecraft.pufferfish_spawn_egg": "Jajco ze kugelfiszōm",
  "item.minecraft.pumpkin_pie": "Kołocz ze banie",
  "item.minecraft.pumpkin_seeds": "Ziorna banie",
  "item.minecraft.purple_bundle": "Flidrowy miyszek",
  "item.minecraft.purple_dye": "Flidrowy farbsztof",
  "item.minecraft.purple_harness": "Flidrowy gyszir",
  "item.minecraft.quartz": "Netherowy kwarc",
  "item.minecraft.rabbit": "Surowy mycok",
  "item.minecraft.rabbit_foot": "Szłapka mycoka",
  "item.minecraft.rabbit_hide": "Mycokowo skōra",
  "item.minecraft.rabbit_spawn_egg": "Jajco ze mycokym",
  "item.minecraft.rabbit_stew": "Ajntop ze mycoka",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ôrnamynt — Formut",
  "item.minecraft.ravager_spawn_egg": "Jajco ze niszczorzym",
  "item.minecraft.raw_copper": "Surowo miydź",
  "item.minecraft.raw_gold": "Surowe złōto",
  "item.minecraft.raw_iron": "Surowe żelazło",
  "item.minecraft.recovery_compass": "Powrotny kōmpas",
  "item.minecraft.red_bundle": "Czyrwōny miyszek",
  "item.minecraft.red_dye": "Czyrwōny farbsztof",
  "item.minecraft.red_harness": "Czyrwōny gyszir",
  "item.minecraft.redstone": "Redstone’owy pulwer",
  "item.minecraft.resin_brick": "Żywicowo cegła",
  "item.minecraft.resin_clump": "Chłopeć żywicy",
  "item.minecraft.rib_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ôrnamynt — Ziobro",
  "item.minecraft.rotten_flesh": "Zgnite miynso",
  "item.minecraft.saddle": "Zatel",
  "item.minecraft.salmon": "Surowy laks",
  "item.minecraft.salmon_bucket": "Kibel ze laksym",
  "item.minecraft.salmon_spawn_egg": "Jajco ze laksym",
  "item.minecraft.scrape_pottery_sherd": "Szpliter ze siekiyrōm",
  "item.minecraft.scute": "Szupa",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ôrnamynt — Wachmajster",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ôrnamynt — Kształtownik",
  "item.minecraft.sheaf_pottery_shard": "Szpliter ze pszynicōm",
  "item.minecraft.sheaf_pottery_sherd": "Szpliter ze pszynicōm",
  "item.minecraft.shears": "Szyry",
  "item.minecraft.sheep_spawn_egg": "Jajco ze ôwcōm",
  "item.minecraft.shelter_pottery_shard": "Szpliter ze agacym",
  "item.minecraft.shelter_pottery_sherd": "Szpliter ze agacym",
  "item.minecraft.shield": "Tarcza",
  "item.minecraft.shield.black": "Czorno tarcza",
  "item.minecraft.shield.blue": "Modro tarcza",
  "item.minecraft.shield.brown": "Brōnotno tarcza",
  "item.minecraft.shield.cyan": "Cyjanowo tarcza",
  "item.minecraft.shield.gray": "Siwo tarcza",
  "item.minecraft.shield.green": "Zielōno tarcza",
  "item.minecraft.shield.light_blue": "Światłomodro tarcza",
  "item.minecraft.shield.light_gray": "Światłosiwo tarcza",
  "item.minecraft.shield.lime": "Limōnkowo tarcza",
  "item.minecraft.shield.magenta": "Purpurowo tarcza",
  "item.minecraft.shield.orange": "Ôranżowo tarcza",
  "item.minecraft.shield.pink": "Rōżowo tarcza",
  "item.minecraft.shield.purple": "Flidrowo tarcza",
  "item.minecraft.shield.red": "Czyrwōno tarcza",
  "item.minecraft.shield.white": "Bioło tarcza",
  "item.minecraft.shield.yellow": "Żōłto tarcza",
  "item.minecraft.shulker_shell": "Shulkerowo szkorupa",
  "item.minecraft.shulker_spawn_egg": "Jajco ze shulkerym",
  "item.minecraft.sign": "Znak",
  "item.minecraft.silence_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ôrnamynt — Cisza",
  "item.minecraft.silverfish_spawn_egg": "Jajco ze rybikym",
  "item.minecraft.skeleton_horse_spawn_egg": "Jajco ze kōniym-szkeletym",
  "item.minecraft.skeleton_spawn_egg": "Jajco ze szkeletym",
  "item.minecraft.skull_banner_pattern": "Muster fany",
  "item.minecraft.skull_banner_pattern.desc": "Trōpio szala",
  "item.minecraft.skull_banner_pattern.new": "Muster fany — Trōpio szala",
  "item.minecraft.skull_pottery_shard": "Szpliter ze szalōm",
  "item.minecraft.skull_pottery_sherd": "Szpliter ze szalōm",
  "item.minecraft.slime_ball": "Szlōmkula",
  "item.minecraft.slime_spawn_egg": "Jajco ze szlamym",
  "item.minecraft.smithing_template": "Kowolski szablōn",
  "item.minecraft.smithing_template.applies_to": "Nakłodo sie na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Przidej sztangelka abo krysztoł",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Pancer",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Przidej tajla pancra",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Sztangelki a krysztoły",
  "item.minecraft.smithing_template.ingredients": "Skłodniki:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Przidej sztangelka netherytu",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Dyjamyntowy sprzynt",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Przidej dyjamyntowy pancer, brōń abo werkcojg",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Sztangelka netherytu",
  "item.minecraft.smithing_template.upgrade": "Ulepszynie:",
  "item.minecraft.sniffer_spawn_egg": "Jajco ze sznupoczym",
  "item.minecraft.snort_pottery_shard": "Szpliter ze sznupoczym",
  "item.minecraft.snort_pottery_sherd": "Szpliter ze sznupoczym",
  "item.minecraft.snout_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ôrnamynt — Niurok",
  "item.minecraft.snow_golem_spawn_egg": "Jajco ze śniyżnym golymym",
  "item.minecraft.snowball": "Śniyżka",
  "item.minecraft.spectral_arrow": "Upiorno strzała",
  "item.minecraft.spider_eye": "Ślypie pajōnka",
  "item.minecraft.spider_spawn_egg": "Jajco ze pajōnkym",
  "item.minecraft.spire_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ôrnamynt — Szpica",
  "item.minecraft.splash_potion": "Ciepany wywar",
  "item.minecraft.splash_potion.effect.awkward": "Ciepany ciyrpki wywar",
  "item.minecraft.splash_potion.effect.empty": "Niystwarzalny ciepany wywar",
  "item.minecraft.splash_potion.effect.fire_resistance": "Ciepany wywar ôbstōnio ôgnia",
  "item.minecraft.splash_potion.effect.harming": "Ciepany wywar krziwdy",
  "item.minecraft.splash_potion.effect.healing": "Ciepany wywar lyczynio",
  "item.minecraft.splash_potion.effect.infested": "Ciepany wywar chrobajstwa",
  "item.minecraft.splash_potion.effect.invisibility": "Ciepany wywar niywidzialności",
  "item.minecraft.splash_potion.effect.leaping": "Ciepany wywar wysokego skokanio",
  "item.minecraft.splash_potion.effect.levitation": "Ciepany wywar lewitacyje",
  "item.minecraft.splash_potion.effect.luck": "Ciepany wywar szczyńścio",
  "item.minecraft.splash_potion.effect.mundane": "Mgły ciepany wywar",
  "item.minecraft.splash_potion.effect.night_vision": "Ciepany wywar widoczności we cimie",
  "item.minecraft.splash_potion.effect.oozing": "Ciepany wywar wyciykanio",
  "item.minecraft.splash_potion.effect.poison": "Ciepany wywar zagidzynio",
  "item.minecraft.splash_potion.effect.regeneration": "Ciepany wywar regyneracyje",
  "item.minecraft.splash_potion.effect.slow_falling": "Ciepany wywar powolnego spadowanio",
  "item.minecraft.splash_potion.effect.slowness": "Ciepany wywar uniyskorzynio",
  "item.minecraft.splash_potion.effect.strength": "Ciepany wywar siyły",
  "item.minecraft.splash_potion.effect.swiftness": "Ciepany wywar gibkości",
  "item.minecraft.splash_potion.effect.thick": "Gynsty ciepany wywar",
  "item.minecraft.splash_potion.effect.turtle_master": "Ciepany wywar żōłwiego majstra",
  "item.minecraft.splash_potion.effect.water": "Ciepano flaszka wody",
  "item.minecraft.splash_potion.effect.water_breathing": "Ciepany wywar dychanio pod wodōm",
  "item.minecraft.splash_potion.effect.weakness": "Ciepany wywar lichoty",
  "item.minecraft.splash_potion.effect.weaving": "Ciepany wywar webera",
  "item.minecraft.splash_potion.effect.wind_charged": "Ciepany wywar naluftowanio",
  "item.minecraft.spruce_boat": "Świyrkowo łōdka",
  "item.minecraft.spruce_chest_boat": "Świyrkowo łōdka ze kastlōm",
  "item.minecraft.spyglass": "Ôptikruła",
  "item.minecraft.squid_spawn_egg": "Jajco ze tintynfiszōm",
  "item.minecraft.stick": "Kijok",
  "item.minecraft.stone_axe": "Kamiynno siekiyra",
  "item.minecraft.stone_hoe": "Kamiynny kopocz",
  "item.minecraft.stone_pickaxe": "Kamiynno haka",
  "item.minecraft.stone_shovel": "Kamiynny ryl",
  "item.minecraft.stone_spear": "Kamiynno szpisa",
  "item.minecraft.stone_sword": "Kamiynny miycz",
  "item.minecraft.stray_spawn_egg": "Jajco ze pōniywiyrokym",
  "item.minecraft.strider_spawn_egg": "Jajco ze smykoczym",
  "item.minecraft.string": "Nitka",
  "item.minecraft.sugar": "Cuker",
  "item.minecraft.suspicious_stew": "Podyjzdrzany ajntop",
  "item.minecraft.sweet_berries": "Słodke borōwki",
  "item.minecraft.tadpole_bucket": "Ajmer ze gowoczym",
  "item.minecraft.tadpole_spawn_egg": "Jajco ze gowoczym",
  "item.minecraft.tide_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ôrnamynt — Wela",
  "item.minecraft.tipped_arrow": "Tōnknyto strzała",
  "item.minecraft.tipped_arrow.effect.awkward": "Tōnknyto strzała",
  "item.minecraft.tipped_arrow.effect.empty": "Niystwarzalno tōnknyto strzała",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strzała ôbstocio ôgnia",
  "item.minecraft.tipped_arrow.effect.harming": "Strzała krziwdy",
  "item.minecraft.tipped_arrow.effect.healing": "Strzała lyczynio",
  "item.minecraft.tipped_arrow.effect.infested": "Strzała chrobajstwa",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strzała niywidzialności",
  "item.minecraft.tipped_arrow.effect.leaping": "Strzała wysokego skokanio",
  "item.minecraft.tipped_arrow.effect.levitation": "Strzała lewitacyje",
  "item.minecraft.tipped_arrow.effect.luck": "Strzała szczyńścio",
  "item.minecraft.tipped_arrow.effect.mundane": "Tōnknyto strzała",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strzała widoczności we cimie",
  "item.minecraft.tipped_arrow.effect.oozing": "Strzała wyciykanio",
  "item.minecraft.tipped_arrow.effect.poison": "Strzała zagidzynio",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strzała regyneracyje",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strzała powolnego spadowanio",
  "item.minecraft.tipped_arrow.effect.slowness": "Strzała uniyskorzynio",
  "item.minecraft.tipped_arrow.effect.strength": "Strzała siyły",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strzała gibkości",
  "item.minecraft.tipped_arrow.effect.thick": "Tōnknyto strzała",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strzała żōłwiego majstra",
  "item.minecraft.tipped_arrow.effect.water": "Strzała cioplanio",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strzała dychanio pod wodōm",
  "item.minecraft.tipped_arrow.effect.weakness": "Strzała lichoty",
  "item.minecraft.tipped_arrow.effect.weaving": "Strzała webera",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strzała naluftowanio",
  "item.minecraft.tnt_minecart": "Wagōn ze TNT",
  "item.minecraft.torchflower_seeds": "Ziorna fakliczki",
  "item.minecraft.totem_of_undying": "Totym niyśmiyrtelności",
  "item.minecraft.trader_llama_spawn_egg": "Jajco z handlyrzowōm lamōm",
  "item.minecraft.trial_key": "Klucz prōby",
  "item.minecraft.trident": "Trzizōmb",
  "item.minecraft.tropical_fish": "Trōpikalo ryba",
  "item.minecraft.tropical_fish_bucket": "Ajmer ze trōpikalnōm rybōm",
  "item.minecraft.tropical_fish_spawn_egg": "Jajco ze trōpikalnōm rybōm",
  "item.minecraft.turtle_helmet": "Żōłwio szkorupa",
  "item.minecraft.turtle_scute": "Żōłwio szupa",
  "item.minecraft.turtle_spawn_egg": "Jajco ze żōłwiym",
  "item.minecraft.vex_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ôrnamynt — Szerga",
  "item.minecraft.vex_spawn_egg": "Jajco ze szergōm",
  "item.minecraft.villager_spawn_egg": "Jajco ze wiyśniokym",
  "item.minecraft.vindicator_spawn_egg": "Jajco ze zymstliwcym",
  "item.minecraft.wandering_trader_spawn_egg": "Jajco z wandrownym handlyrzym",
  "item.minecraft.ward_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ôrnamynt — Wacha",
  "item.minecraft.warden_spawn_egg": "Jajco ze wachmajstrym",
  "item.minecraft.warped_fungus_on_a_stick": "Szagi grzib na kijoku",
  "item.minecraft.water_bucket": "Kibel wody",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ôrnamynt — Wegwajzer",
  "item.minecraft.wheat": "Pszynica",
  "item.minecraft.wheat_seeds": "Ziorna pszynice",
  "item.minecraft.white_bundle": "Bioły miyszek",
  "item.minecraft.white_dye": "Bioły farbsztof",
  "item.minecraft.white_harness": "Bioły gyszir",
  "item.minecraft.wild_armor_trim_smithing_template": "Kowolski szablōn",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ôrnamynt — Dzicz",
  "item.minecraft.wind_charge": "Wietrzny ladōnek",
  "item.minecraft.witch_spawn_egg": "Jajco ze heksōm",
  "item.minecraft.wither_skeleton_spawn_egg": "Jajco ze witherowym szkeletym",
  "item.minecraft.wither_spawn_egg": "Jajco ze witherym",
  "item.minecraft.wolf_armor": "Wilczy pancer",
  "item.minecraft.wolf_spawn_egg": "Jajco ze wilkym",
  "item.minecraft.wooden_axe": "Drzewnianno siekiyra",
  "item.minecraft.wooden_hoe": "Drzewnianny kopocz",
  "item.minecraft.wooden_pickaxe": "Drzewnianno haka",
  "item.minecraft.wooden_shovel": "Drzewnianny ryl",
  "item.minecraft.wooden_spear": "Drzewnianno szpisa",
  "item.minecraft.wooden_sword": "Drzewnianny miycz",
  "item.minecraft.writable_book": "Ksiōnżka ze fyjdrym",
  "item.minecraft.written_book": "Naszkryftano ksiōnżka",
  "item.minecraft.yellow_bundle": "Żōłty miyszek",
  "item.minecraft.yellow_dye": "Żōłty farbsztof",
  "item.minecraft.yellow_harness": "Żōłty gyszir",
  "item.minecraft.zoglin_spawn_egg": "Jajco ze zoglinym",
  "item.minecraft.zombie_horse_spawn_egg": "Jajco ze kōniym-umarlokym",
  "item.minecraft.zombie_nautilus_spawn_egg": "Jajco ze łodzikym-umarlokym",
  "item.minecraft.zombie_spawn_egg": "Jajco ze umarlokym",
  "item.minecraft.zombie_villager_spawn_egg": "Jajco ze wiyśniokym-umarlokym",
  "item.minecraft.zombified_piglin_spawn_egg": "Jajco ze piglinym-umarlokiym"
}
export const szl = items; 
